{
  "Chemicals": {
    "Fertilizers": {
      "NaN": {
        "category_proxy": {
          "I don't know (fertiliser)": {
            "description": "Original Emission Factor name: 'Fertiliser - binary NK - N share', with value 2.967 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 2.967,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Ammonium nitrate 33.5": {
            "description": "Original Emission Factor name: 'Ammonium nitrate 33.5% - manufacture - 0,335', with value 3.785 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 3.785,
            "unit": "kgCO2eq/kg"
          },
          "Ammonium sulfo phosphate asp": {
            "description": "Original Emission Factor name: 'Ammonium sulfo-phosphate (ASP)', with value 1.749 kgCO2eq/kg for geography 'europe', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 1.749,
            "unit": "kgCO2eq/kg"
          },
          "Ammonium sulphate": {
            "description": "Original Emission Factor name: 'Ammonium sulphate', with value 0.733 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 0.733,
            "unit": "kgCO2eq/kg"
          },
          "Anhydrous ammonia": {
            "description": "Original Emission Factor name: 'Anhydrous ammonia - manufacture', with value 2.967 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 2.967,
            "unit": "kgCO2eq/kg"
          },
          "Argon": {
            "description": "Original Emission Factor name: 'argon', with value 2.2034624 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - gases",
            "impact": 2.2034624,
            "unit": "kgCO2eq/kg"
          },
          "Average fungicide": {
            "description": "Original Emission Factor name: 'Average fungicide - manufacture', with value 6.1 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - phytosanitary",
            "impact": 6.1,
            "unit": "kgCO2eq/kg"
          },
          "Average herbicide": {
            "description": "Original Emission Factor name: 'Average herbicide - manufacture', with value 9.1 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - phytosanitary",
            "impact": 9.1,
            "unit": "kgCO2eq/kg"
          },
          "Banol": {
            "description": "Original Emission Factor name: 'Banol', with value 9.2 kgCO2eq/kg for geography 'caribbean - overseas departments of france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - phytosanitary",
            "impact": 9.2,
            "unit": "kgCO2eq/kg"
          },
          "Bentonite kaolin": {
            "description": "Original Emission Factor name: 'Bentonite, kaolin', with value 1.1 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 1.1,
            "unit": "kgCO2eq/kg"
          },
          "Boron": {
            "description": "Original Emission Factor name: 'boron', with value 48.64453666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - particular metals",
            "impact": 48.64453666666667,
            "unit": "kgCO2eq/kg"
          },
          "Brine sodium chloride": {
            "description": "Original Emission Factor name: 'Brine (sodium  chloride)', with value 0.169 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 0.169,
            "unit": "kgCO2eq/kg"
          },
          "Calcium ammonium nitrate 30 can": {
            "description": "Original Emission Factor name: 'Calcium ammonium nitrate 27% (CAN) - manufacture - lime 30% (CAN)', with value 3.968 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 3.968,
            "unit": "kgCO2eq/kg"
          },
          "Calcium carbonate": {
            "description": "Original Emission Factor name: 'Calcium carbonate', with value 0.075 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 0.075,
            "unit": "kgCO2eq/kg"
          },
          "Calculous d lacid": {
            "description": "Original Emission Factor name: 'Calculous D,Lacid', with value 3.3 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 3.3,
            "unit": "kgCO2eq/kg"
          },
          "Carbon dioxide liquid": {
            "description": "Original Emission Factor name: 'carbon dioxide liquid', with value 0.4647309866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - gases",
            "impact": 0.4647309866666667,
            "unit": "kgCO2eq/kg"
          },
          "Carbon dioxyde from chemical origin": {
            "description": "Original Emission Factor name: 'Carbon dioxyde from chemical origin', with value 0.818 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 0.818,
            "unit": "kgCO2eq/kg"
          },
          "Carbon monoxide": {
            "description": "Original Emission Factor name: 'carbon monoxide', with value 1.395 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - gases",
            "impact": 1.395,
            "unit": "kgCO2eq/kg"
          },
          "Citric acid": {
            "description": "Original Emission Factor name: 'Citric acid', with value 3.3 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 3.3,
            "unit": "kgCO2eq/kg"
          },
          "Cobalt oxide coo": {
            "description": "Original Emission Factor name: 'cobalt oxide coo', with value 24.18203133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 24.18203133333333,
            "unit": "kgCO2eq/kg"
          },
          "Fertilizer n": {
            "description": "Original Emission Factor name: 'fertilizer n', with value 3.8798539333333335 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - fertilisers inorganic and organic",
            "impact": 3.8798539333333335,
            "unit": "kgCO2eq/kg"
          },
          "Fertilizer p": {
            "description": "Original Emission Factor name: 'fertilizer p', with value 1.1868878 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - fertilisers inorganic and organic",
            "impact": 1.1868878,
            "unit": "kgCO2eq/kg"
          },
          "Fertilizers k": {
            "description": "Original Emission Factor name: 'fertilizer k', with value 0.7627414 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - fertilisers inorganic and organic",
            "impact": 0.7627414,
            "unit": "kgCO2eq/kg"
          },
          "Growth regulators": {
            "description": "Original Emission Factor name: 'Growth regulators', with value 8.59 kgCO2eq/kg for geography 'europe - france', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - phytosanitary",
            "impact": 8.59,
            "unit": "kgCO2eq/kg"
          },
          "H2o2 70 in h2o": {
            "description": "Original Emission Factor name: 'h2o2 hydrogen peroxide 70 in h2o', with value 0.5340560666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 0.5340560666666667,
            "unit": "kgCO2eq/kg"
          },
          "Hydrogen methane to hydrogen smr": {
            "description": "Original Emission Factor name: 'hydrogen methane to hydrogen smr', with value 11.756982 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - gases",
            "impact": 11.756982,
            "unit": "kgCO2eq/kg"
          },
          "Insecticide": {
            "description": "Original Emission Factor name: 'Insecticide - average - manufacture', with value 25.4 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - phytosanitary",
            "impact": 25.4,
            "unit": "kgCO2eq/kg"
          },
          "Kieselguhr diatomites perlites": {
            "description": "Original Emission Factor name: 'Kieselguhr, diatomites, perlites', with value 1.01 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 1.01,
            "unit": "kgCO2eq/kg"
          },
          "Koh": {
            "description": "Original Emission Factor name: 'koh potassium hydroxide', with value 1.6966309333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 1.6966309333333334,
            "unit": "kgCO2eq/kg"
          },
          "Lime": {
            "description": "Original Emission Factor name: 'hydrated lime  oh 2 without transport', with value 0.9772478666666669 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 0.9772478666666669,
            "unit": "kgCO2eq/kg"
          },
          "Liquid sulphur dioxyde": {
            "description": "Original Emission Factor name: 'Liquid sulphur dioxyde', with value 0.44 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 0.44,
            "unit": "kgCO2eq/kg"
          },
          "Manganese dioxide": {
            "description": "Original Emission Factor name: 'manganese dioxide', with value 2.2603512666666665 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 2.2603512666666665,
            "unit": "kgCO2eq/kg"
          },
          "Micro organisms and yeast bacteria extracts": {
            "description": "Original Emission Factor name: 'Micro-organisms et extracts (bacterias,  yeasts...)', with value 2.2 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 2.2,
            "unit": "kgCO2eq/kg"
          },
          "Molluscides methiocarbe": {
            "description": "Original Emission Factor name: 'Molluscides (methiocarbe) - manufacture', with value 8.89 kgCO2eq/kg for geography 'europe - france', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - phytosanitary",
            "impact": 8.89,
            "unit": "kgCO2eq/kg"
          },
          "Nickel in ferronickel 27": {
            "description": "Original Emission Factor name: 'nickel in ferronickel 27', with value 45.095508 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 45.095508,
            "unit": "kgCO2eq/kg"
          },
          "Nickel in nickel sufate 22 for car batteries": {
            "description": "Original Emission Factor name: 'nickel in nickel sufate 22 for car batteries', with value 24.595508 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 24.595508,
            "unit": "kgCO2eq/kg"
          },
          "Nitrogen liquid": {
            "description": "Original Emission Factor name: 'nitrogen liquid', with value 0.21643796 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - gases",
            "impact": 0.21643796,
            "unit": "kgCO2eq/kg"
          },
          "Nitrogen solution": {
            "description": "Original Emission Factor name: 'Nitrogen solution - manufacture', with value 4.76 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 4.76,
            "unit": "kgCO2eq/kg"
          },
          "Oxigen liquid": {
            "description": "Original Emission Factor name: 'oxigen liquid', with value 1.2 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - chemicals - fertilisers inorganic and organic",
            "impact": 1.2,
            "unit": "kgCO₂e/kg"
          },
          "Phosphate ammonium nitrate": {
            "description": "Original Emission Factor name: 'Phosphate ammonium nitrate', with value 1.684 kgCO2eq/kg for geography 'europe', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 1.684,
            "unit": "kgCO2eq/kg"
          },
          "Phytosanitary": {
            "description": "Original Emission Factor name: 'Phytosanitary', with value 9.2 kgCO2eq/kg for geography 'europe', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - phytosanitary",
            "impact": 9.2,
            "unit": "kgCO2eq/kg"
          },
          "Piled manure": {
            "description": "Original Emission Factor name: 'Piled manure', with value 0.00332 kgCO2eq/kg for geography 'europe', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 0.00332,
            "unit": "kgCO2eq/kg"
          },
          "Potassium bisulphite": {
            "description": "Original Emission Factor name: 'Bisulfite de potassium', with value 1.47 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 1.47,
            "unit": "kgCO2eq/kg"
          },
          "Potassium chloride": {
            "description": "Original Emission Factor name: 'Potassium chloride - manufacture', with value 0.449 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 0.449,
            "unit": "kgCO2eq/kg"
          },
          "Silicagel": {
            "description": "Original Emission Factor name: 'silicagel', with value 3.455141933333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 3.455141933333334,
            "unit": "kgCO2eq/kg"
          },
          "Sodium silicate": {
            "description": "Original Emission Factor name: 'sodium silicate', with value 1.3035710666666669 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 1.3035710666666669,
            "unit": "kgCO2eq/kg"
          },
          "Sodium sulphate": {
            "description": "Original Emission Factor name: 'sodium sulphate', with value 3.455141933333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 3.455141933333334,
            "unit": "kgCO2eq/kg"
          },
          "Sorbic acid": {
            "description": "Original Emission Factor name: 'Sorbic acid', with value 0.807 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 0.807,
            "unit": "kgCO2eq/kg"
          },
          "Sulfochaux": {
            "description": "Original Emission Factor name: 'Sulfochaux', with value 0.367 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 0.367,
            "unit": "kgCO2eq/kg"
          },
          "Sulfosol": {
            "description": "Original Emission Factor name: 'Sulfosol', with value 3.67 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 3.67,
            "unit": "kgCO2eq/kg"
          },
          "Tannin": {
            "description": "Original Emission Factor name: 'Tannin', with value 2.2 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 2.2,
            "unit": "kgCO2eq/kg"
          },
          "Thomas slag": {
            "description": "Original Emission Factor name: 'Trisuperphosphate (TSP) - manufacture', with value 1.35 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 1.35,
            "unit": "kgCO2eq/kg"
          },
          "Titanium dioxide": {
            "description": "Original Emission Factor name: 'titanium dioxide', with value 7.544417333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 7.544417333333334,
            "unit": "kgCO2eq/kg"
          },
          "Trisuperphosphate tsp": {
            "description": "Original Emission Factor name: 'Trisuperphosphate (TSP) - manufacture', with value 1.35 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - nitrogen fertilizers and compounds",
            "impact": 1.35,
            "unit": "kgCO2eq/kg"
          },
          "Urea": {
            "description": "Original Emission Factor name: 'urea adblue', with value 4.8498174 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 4.8498174,
            "unit": "kgCO2eq/kg"
          },
          "Vine rectified ethanol": {
            "description": "Original Emission Factor name: 'Vine rectified ethanol', with value 1.83 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - fertilizers phytosanitary ... - chemicals specific to viticulture",
            "impact": 1.83,
            "unit": "kgCO2eq/kg"
          },
          "Zinc oxide": {
            "description": "Original Emission Factor name: 'zinc oxide', with value 3.668696866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 3.668696866666667,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Organic & inorganic": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for chemicals - organic & inorganic)": {
            "description": "Original Emission Factor name: 'styrene', with value 2.0900000000000003 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 2.0900000000000003,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Acetic acid trade mix.": {
            "description": "Original Emission Factor name: 'acetic acid trade mix', with value 0.1955354266666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - acids organic",
            "impact": 0.1955354266666666,
            "unit": "kgCO2eq/kg"
          },
          "Acetic anhydride trade mix": {
            "description": "Original Emission Factor name: 'acetic anhydride trade mix', with value 1.0884008 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - acids organic",
            "impact": 1.0884008,
            "unit": "kgCO2eq/kg"
          },
          "Acrylonitrile": {
            "description": "Original Emission Factor name: 'acrylonitrile', with value 3.3067696 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 3.3067696,
            "unit": "kgCO2eq/kg"
          },
          "Benzene": {
            "description": "Original Emission Factor name: 'benzene', with value 1.8600000000000003 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 1.8600000000000003,
            "unit": "kgCO2eq/kg"
          },
          "Carbon black": {
            "description": "Original Emission Factor name: 'carbon black', with value 3.249372933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 3.249372933333333,
            "unit": "kgCO2eq/kg"
          },
          "Chlorine": {
            "description": "Original Emission Factor name: 'chlorine chlor alkali industry 2022', with value 0.71 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - gases",
            "impact": 0.71,
            "unit": "kgCO2eq/kg"
          },
          "Ethylene glycol": {
            "description": "Original Emission Factor name: 'monoethylene glycol meg', with value 1.58 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 1.58,
            "unit": "kgCO2eq/kg"
          },
          "Hcl": {
            "description": "Original Emission Factor name: 'hcl hydrochloric acid', with value 0.2090050466666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - acids inorganic",
            "impact": 0.2090050466666666,
            "unit": "kgCO2eq/kg"
          },
          "Methanol": {
            "description": "Original Emission Factor name: 'methanol', with value 0.917459 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 0.917459,
            "unit": "kgCO2eq/kg"
          },
          "Nitric Acid": {
            "description": "Original Emission Factor name: 'nitric acid', with value 0.6364783466666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - acids inorganic",
            "impact": 0.6364783466666667,
            "unit": "kgCO2eq/kg"
          },
          "Pentane blowing agent": {
            "description": "Original Emission Factor name: 'pentane blowing agent', with value 1.1312888 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 1.1312888,
            "unit": "kgCO2eq/kg"
          },
          "Phenol": {
            "description": "Original Emission Factor name: 'phenol', with value 1.7900000000000005 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 1.7900000000000005,
            "unit": "kgCO2eq/kg"
          },
          "Phosphoric acid": {
            "description": "Original Emission Factor name: 'phosphoric acid', with value 0.46539374 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - acids inorganic",
            "impact": 0.46539374,
            "unit": "kgCO2eq/kg"
          },
          "Propylene": {
            "description": "Original Emission Factor name: 'propylene propene', with value 1.44 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 1.44,
            "unit": "kgCO2eq/kg"
          },
          "Quicklime": {
            "description": "Original Emission Factor name: 'quicklime cao without transport', with value 1.2689951333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 1.2689951333333334,
            "unit": "kgCO2eq/kg"
          },
          "Sodium chloride": {
            "description": "Original Emission Factor name: 'sodium chloride nacl plasticseurope', with value 0.06 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 0.06,
            "unit": "kgCO2eq/kg"
          },
          "Sodium hydroxide": {
            "description": "Original Emission Factor name: 'sodium hydroxide naoh plasticseurope 2013', with value 0.8600000000000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - inorganic",
            "impact": 0.8600000000000001,
            "unit": "kgCO2eq/kg"
          },
          "Styrene": {
            "description": "Original Emission Factor name: 'styrene', with value 2.0900000000000003 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 2.0900000000000003,
            "unit": "kgCO2eq/kg"
          },
          "Toluene": {
            "description": "Original Emission Factor name: 'toluene', with value 1.22 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 1.22,
            "unit": "kgCO2eq/kg"
          },
          "Xylene": {
            "description": "Original Emission Factor name: 'xylene', with value 1.43 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: chemicals - materials - chemicals - organic",
            "impact": 1.43,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Paints, varnishes, coatings, ink, mastics": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for chemicals - paints, varnishes, coatings, ink, mastics)": {
            "description": "Original Emission Factor name: 'PU  leather lacquer - black', with value 6.74 kgCO2eq/kg for geography 'global', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - paintings and resins",
            "impact": 6.74,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Acrylic varnish": {
            "description": "Original Emission Factor name: 'Acrylic  varnish', with value 1.51 kgCO2eq/kg for geography 'global', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - paintings and resins",
            "impact": 1.51,
            "unit": "kgCO2eq/kg"
          },
          "Epoxy adhesive": {
            "description": "Original Emission Factor name: 'Epoxy  adhesive - mixture', with value 6.87 kgCO2eq/kg for geography 'global', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - paintings and resins",
            "impact": 6.87,
            "unit": "kgCO2eq/kg"
          },
          "Pigments general for offset .": {
            "description": "Original Emission Factor name: 'pigments general for offset .', with value 1.2 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - chemicals",
            "impact": 1.2,
            "unit": "kgCO₂e/kg"
          },
          "Pu leather lacquer": {
            "description": "Original Emission Factor name: 'PU  leather lacquer - black', with value 6.74 kgCO2eq/kg for geography 'global', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - plastics and chemicals - chemical products - paintings and resins",
            "impact": 6.74,
            "unit": "kgCO2eq/kg"
          },
          "Solvent based paint transparent incl evaporation solvent": {
            "description": "Original Emission Factor name: 'solvent based paint transparent incl evaporation solvent', with value 3.7421874666666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - paints",
            "impact": 3.7421874666666666,
            "unit": "kgCO2eq/kg"
          },
          "Solvent based paint white incl evaporation solvent": {
            "description": "Original Emission Factor name: 'solvent based paint white incl evaporation solvent', with value 4.363466933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - paints",
            "impact": 4.363466933333333,
            "unit": "kgCO2eq/kg"
          },
          "Water based paint transparent": {
            "description": "Original Emission Factor name: 'water based paint transparent', with value 2.260869533333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - paints",
            "impact": 2.260869533333333,
            "unit": "kgCO2eq/kg"
          },
          "Water based paint white": {
            "description": "Original Emission Factor name: 'water based paint white', with value 3.204360266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - paints",
            "impact": 3.204360266666667,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    }
  },
  "Electricity": {
    "Location-based": {
      "NaN": {
        "category_proxy": {
          "I don't know (average - global)": {
            "description": "Lifecycle carbon intensity of electricity for global average, 0.458 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4583,
            "unit": "kgCO₂eq/kWh"
          }
        },
        "emission_factors": {
          "Australia": {
            "description": "Lifecycle carbon intensity of electricity for Australia, 0.525 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5252,
            "unit": "kgCO₂eq/kWh"
          },
          "Austria": {
            "description": "Lifecycle carbon intensity of electricity for Austria, 0.117 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1169,
            "unit": "kgCO₂eq/kWh"
          },
          "Average - africa": {
            "description": "Lifecycle carbon intensity of electricity for Africa average, 0.530 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5299,
            "unit": "kgCO₂eq/kWh"
          },
          "Average - european union": {
            "description": "Lifecycle carbon intensity of electricity for European Union (EU-27) average, 0.210 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.2099,
            "unit": "kgCO₂eq/kWh"
          },
          "Average - latin america": {
            "description": "Lifecycle carbon intensity of electricity for Latin America and Caribbean average, 0.247 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.247,
            "unit": "kgCO₂eq/kWh"
          },
          "Average - middle east": {
            "description": "Lifecycle carbon intensity of electricity for Middle East average, 0.635 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.6346,
            "unit": "kgCO₂eq/kWh"
          },
          "Average - non oecd europe and eurasia": {
            "description": "Lifecycle carbon intensity for non-OECD Europe and Eurasia, computed as the simple mean of 17 constituent countries (Russia, Belarus, Ukraine, Moldova, Caucasus, Central Asia, Western Balkans), 0.469 kgCO₂eq/kWh (latest values 2022-2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4686,
            "unit": "kgCO₂eq/kWh"
          },
          "Belgium": {
            "description": "Lifecycle carbon intensity of electricity for Belgium, 0.150 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1498,
            "unit": "kgCO₂eq/kWh"
          },
          "Brazil": {
            "description": "Lifecycle carbon intensity of electricity for Brazil, 0.110 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.11,
            "unit": "kgCO₂eq/kWh"
          },
          "Bulgaria": {
            "description": "Lifecycle carbon intensity of electricity for Bulgaria, 0.276 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.2756,
            "unit": "kgCO₂eq/kWh"
          },
          "Canada": {
            "description": "Lifecycle carbon intensity of electricity for Canada, 0.191 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1907,
            "unit": "kgCO₂eq/kWh"
          },
          "China": {
            "description": "Lifecycle carbon intensity of electricity for China, 0.525 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5253,
            "unit": "kgCO₂eq/kWh"
          },
          "Chinese taipei": {
            "description": "Lifecycle carbon intensity of electricity for Taiwan (Chinese Taipei), 0.633 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.6332,
            "unit": "kgCO₂eq/kWh"
          },
          "Croatia": {
            "description": "Lifecycle carbon intensity of electricity for Croatia, 0.159 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1585,
            "unit": "kgCO₂eq/kWh"
          },
          "Cyprus": {
            "description": "Lifecycle carbon intensity of electricity for Cyprus, 0.489 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.489,
            "unit": "kgCO₂eq/kWh"
          },
          "Czech republic": {
            "description": "Lifecycle carbon intensity of electricity for Czechia, 0.401 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4015,
            "unit": "kgCO₂eq/kWh"
          },
          "Denmark": {
            "description": "Lifecycle carbon intensity of electricity for Denmark, 0.114 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1144,
            "unit": "kgCO₂eq/kWh"
          },
          "Egypt": {
            "description": "Lifecycle carbon intensity of electricity for Egypt, 0.563 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5632,
            "unit": "kgCO₂eq/kWh"
          },
          "Estonia": {
            "description": "Lifecycle carbon intensity of electricity for Estonia, 0.319 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.3191,
            "unit": "kgCO₂eq/kWh"
          },
          "Finland": {
            "description": "Lifecycle carbon intensity of electricity for Finland, 0.057 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.0575,
            "unit": "kgCO₂eq/kWh"
          },
          "France": {
            "description": "Lifecycle carbon intensity of electricity for France, 0.041 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.0414,
            "unit": "kgCO₂eq/kWh"
          },
          "Germany": {
            "description": "Lifecycle carbon intensity of electricity for Germany, 0.330 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.3296,
            "unit": "kgCO₂eq/kWh"
          },
          "Gibraltar": {
            "description": "Lifecycle carbon intensity of electricity for Gibraltar, 0.591 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5909,
            "unit": "kgCO₂eq/kWh"
          },
          "Greece": {
            "description": "Lifecycle carbon intensity of electricity for Greece, 0.315 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.3151,
            "unit": "kgCO₂eq/kWh"
          },
          "Hong kong": {
            "description": "Lifecycle carbon intensity of electricity for Hong Kong, 0.675 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.6755,
            "unit": "kgCO₂eq/kWh"
          },
          "Hungary": {
            "description": "Lifecycle carbon intensity of electricity for Hungary, 0.163 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.163,
            "unit": "kgCO₂eq/kWh"
          },
          "Iceland": {
            "description": "Lifecycle carbon intensity of electricity for Iceland, 0.028 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.0278,
            "unit": "kgCO₂eq/kWh"
          },
          "India": {
            "description": "Lifecycle carbon intensity of electricity for India, 0.670 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.6701,
            "unit": "kgCO₂eq/kWh"
          },
          "India - Eastern": {
            "description": "Lifecycle carbon intensity of electricity for India (Eastern: Bihar, Jharkhand, Odisha), 0.777 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.7772,
            "unit": "kgCO₂eq/kWh"
          },
          "India - North-Eastern": {
            "description": "Lifecycle carbon intensity of electricity for India (North-Eastern: Assam, Arunachal Pradesh), 0.390 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.3897,
            "unit": "kgCO₂eq/kWh"
          },
          "India - Northern": {
            "description": "Lifecycle carbon intensity of electricity for India (Northern: Delhi, Uttar Pradesh, Rajasthan), 0.540 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5397,
            "unit": "kgCO₂eq/kWh"
          },
          "India - Southern": {
            "description": "Lifecycle carbon intensity of electricity for India (Southern: Telangana, Karnataka, Kerala), 0.528 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5284,
            "unit": "kgCO₂eq/kWh"
          },
          "India - Western": {
            "description": "Lifecycle carbon intensity of electricity for India (Western: Maharashtra, Gujarat), 0.675 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.6753,
            "unit": "kgCO₂eq/kWh"
          },
          "Indonesia": {
            "description": "Lifecycle carbon intensity of electricity for Indonesia, 0.680 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.6803,
            "unit": "kgCO₂eq/kWh"
          },
          "Ireland": {
            "description": "Lifecycle carbon intensity of electricity for Ireland, 0.257 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.2565,
            "unit": "kgCO₂eq/kWh"
          },
          "Israel": {
            "description": "Lifecycle carbon intensity of electricity for Israel, 0.493 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4927,
            "unit": "kgCO₂eq/kWh"
          },
          "Italy": {
            "description": "Lifecycle carbon intensity of electricity for Italy, 0.285 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.2848,
            "unit": "kgCO₂eq/kWh"
          },
          "Japan": {
            "description": "Lifecycle carbon intensity of electricity for Japan, 0.477 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4773,
            "unit": "kgCO₂eq/kWh"
          },
          "Latvia": {
            "description": "Lifecycle carbon intensity of electricity for Latvia, 0.139 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1388,
            "unit": "kgCO₂eq/kWh"
          },
          "Lithuania": {
            "description": "Lifecycle carbon intensity of electricity for Lithuania, 0.138 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1384,
            "unit": "kgCO₂eq/kWh"
          },
          "Luxembourg": {
            "description": "Lifecycle carbon intensity of electricity for Luxembourg, 0.123 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1234,
            "unit": "kgCO₂eq/kWh"
          },
          "Malaysia": {
            "description": "Lifecycle carbon intensity of electricity for Malaysia, 0.602 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.602,
            "unit": "kgCO₂eq/kWh"
          },
          "Malta": {
            "description": "Lifecycle carbon intensity of electricity for Malta, 0.484 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.484,
            "unit": "kgCO₂eq/kWh"
          },
          "Mexico": {
            "description": "Lifecycle carbon intensity of electricity for Mexico, 0.474 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.474,
            "unit": "kgCO₂eq/kWh"
          },
          "Netherlands": {
            "description": "Lifecycle carbon intensity of electricity for Netherlands, 0.254 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.2536,
            "unit": "kgCO₂eq/kWh"
          },
          "New zealand": {
            "description": "Lifecycle carbon intensity of electricity for New Zealand, 0.093 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.0928,
            "unit": "kgCO₂eq/kWh"
          },
          "Norway": {
            "description": "Lifecycle carbon intensity of electricity for Norway, 0.028 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.0281,
            "unit": "kgCO₂eq/kWh"
          },
          "Pakistan": {
            "description": "Lifecycle carbon intensity of electricity for Pakistan, 0.347 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.3466,
            "unit": "kgCO₂eq/kWh"
          },
          "Philippines": {
            "description": "Lifecycle carbon intensity of electricity for Philippines, 0.588 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5883,
            "unit": "kgCO₂eq/kWh"
          },
          "Poland": {
            "description": "Lifecycle carbon intensity of electricity for Poland, 0.589 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5886,
            "unit": "kgCO₂eq/kWh"
          },
          "Portugal": {
            "description": "Lifecycle carbon intensity of electricity for Portugal, 0.128 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1279,
            "unit": "kgCO₂eq/kWh"
          },
          "Romania": {
            "description": "Lifecycle carbon intensity of electricity for Romania, 0.251 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.2507,
            "unit": "kgCO₂eq/kWh"
          },
          "Russian federation": {
            "description": "Lifecycle carbon intensity of electricity for Russia, 0.450 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4497,
            "unit": "kgCO₂eq/kWh"
          },
          "Saudi arabia": {
            "description": "Lifecycle carbon intensity of electricity for Saudi Arabia, 0.692 kgCO₂eq/kWh (2024). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.692,
            "unit": "kgCO₂eq/kWh"
          },
          "Singapore": {
            "description": "Lifecycle carbon intensity of electricity for Singapore, 0.497 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4971,
            "unit": "kgCO₂eq/kWh"
          },
          "Slovak republic": {
            "description": "Lifecycle carbon intensity of electricity for Slovakia, 0.095 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.0948,
            "unit": "kgCO₂eq/kWh"
          },
          "Slovenia": {
            "description": "Lifecycle carbon intensity of electricity for Slovenia, 0.183 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1833,
            "unit": "kgCO₂eq/kWh"
          },
          "South africa": {
            "description": "Lifecycle carbon intensity of electricity for South Africa, 0.699 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.6993,
            "unit": "kgCO₂eq/kWh"
          },
          "South korea": {
            "description": "Lifecycle carbon intensity of electricity for South Korea, 0.417 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4171,
            "unit": "kgCO₂eq/kWh"
          },
          "Spain": {
            "description": "Lifecycle carbon intensity of electricity for Spain, 0.154 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.1536,
            "unit": "kgCO₂eq/kWh"
          },
          "Sweden": {
            "description": "Lifecycle carbon intensity of electricity for Sweden, 0.035 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.0353,
            "unit": "kgCO₂eq/kWh"
          },
          "Switzerland": {
            "description": "Lifecycle carbon intensity of electricity for Switzerland, 0.039 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.0392,
            "unit": "kgCO₂eq/kWh"
          },
          "Thailand": {
            "description": "Lifecycle carbon intensity of electricity for Thailand, 0.546 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.5457,
            "unit": "kgCO₂eq/kWh"
          },
          "Turkey": {
            "description": "Lifecycle carbon intensity of electricity for Turkey, 0.475 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.4747,
            "unit": "kgCO₂eq/kWh"
          },
          "Uk": {
            "description": "Lifecycle carbon intensity of electricity for United Kingdom, 0.217 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.2174,
            "unit": "kgCO₂eq/kWh"
          },
          "Ukraine": {
            "description": "Lifecycle carbon intensity of electricity for Ukraine, 0.250 kgCO₂eq/kWh (2022). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.2505,
            "unit": "kgCO₂eq/kWh"
          },
          "United states": {
            "description": "Lifecycle carbon intensity of electricity for United States, 0.384 kgCO₂eq/kWh (2025). Source: Ember Yearly Electricity Data via Our World in Data (CC BY).",
            "impact": 0.3844,
            "unit": "kgCO₂eq/kWh"
          }
        }
      }
    },
    "Market-based - contractual": {
      "Fossil": {
        "emission_factors": {
          "Coal": {
            "impact": 1.076805279,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity coal us china 38 efficiency', with value 1.076805279 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Natural gas": {
            "impact": 0.544111076,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity gas us china 60 efficiency', with value 0.544111076 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Oil": {
            "impact": 0.872882255,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity oil us china 45 efficiency', with value 0.872882255 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Electricity generation from coal": {
            "impact": 1.076805279,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity coal us china 38 efficiency', with value 1.076805279 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Electricity generation from natural gas": {
            "impact": 0.544111076,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity gas us china 60 efficiency', with value 0.544111076 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Electricity generation from oil": {
            "impact": 0.872882255,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity oil us china 45 efficiency', with value 0.872882255 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          }
        }
      },
      "Low-carbon": {
        "emission_factors": {
          "Nuclear": {
            "impact": 0.008089676,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity nuclear us', with value 0.008089676 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Electricity generation from nuclear": {
            "impact": 0.008089676,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity nuclear us', with value 0.008089676 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          }
        }
      },
      "Renewable": {
        "emission_factors": {
          "Wind": {
            "impact": 0.008147237,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity from offshore 5mw capacity factor 0.47', with value 0.008147237 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Solar PV": {
            "impact": 0.092574118,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'pv panel irradiation 1100 kwh per m2 in mj', with value 0.092574118 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Hydropower": {
            "impact": 0.006000812,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'hydro electric power norway', with value 0.006000812 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Geothermal": {
            "impact": 0.038,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Biomass": {
            "impact": 0.024,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Green hydrogen": {
            "impact": 0.05,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          }
        }
      }
    },
    "On-site / direct combustion": {
      "Fossil": {
        "emission_factors": {
          "Natural gas": {
            "impact": 0.544111076,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity gas us china 60 efficiency', with value 0.544111076 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Oil / diesel": {
            "impact": 0.872882255,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity oil us china 45 efficiency', with value 0.872882255 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          }
        }
      },
      "Renewable": {
        "emission_factors": {
          "Solar PV": {
            "impact": 0.092574118,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'pv panel irradiation 1100 kwh per m2 in mj', with value 0.092574118 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Wind": {
            "impact": 0.008147237,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'electricity from offshore 5mw capacity factor 0.47', with value 0.008147237 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Biomass": {
            "impact": 0.024,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Hydropower": {
            "impact": 0.006000812,
            "unit": "kgCO₂e/kWh",
            "description": "Original Emission Factor name: 'hydro electric power norway', with value 0.006000812 kgCO₂e/kWh for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: energy - electricity by fuel"
          },
          "Geothermal": {
            "impact": 0.038,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          }
        }
      }
    }
  },
  "Heat / steam": {
    "On-site / direct combustion": {
      "Fossil": {
        "emission_factors": {
          "Anthracite coal": {
            "impact": 0.418423176,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'heat from anthracite coal 30.7 mj kg including combustion co2', with value 0.418423176 kgCO2eq/kWh for geography 'global', from idemat 2025 2025, within the following taxonomy: heat - energy - heat"
          },
          "Bituminous coal": {
            "impact": 0.37474356,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'heat from coal bituminous 26.4 mj kg including combustion co2', with value 0.37474356 kgCO2eq/kWh for geography 'global', from idemat 2025 2025, within the following taxonomy: heat - energy - heat"
          },
          "Coal industrial": {
            "impact": 0.33944,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels solid fuels coal industrial', with value 0.33944 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - solid fuels - coal industrial"
          },
          "Coking coal": {
            "impact": 0.37675,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels solid fuels coking coal', with value 0.37675 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - solid fuels - coking coal"
          },
          "Petroleum coke": {
            "impact": 0.35887,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels solid fuels petroleum coke', with value 0.35887 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - solid fuels - petroleum coke"
          },
          "Natural gas": {
            "impact": 0.2027,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels gaseous fuels natural gas', with value 0.2027 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - gaseous fuels - natural gas"
          },
          "Natural gas 100 mineral blend": {
            "impact": 0.20489,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels gaseous fuels natural gas 100 mineral blend', with value 0.20489 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - gaseous fuels - natural gas 100 mineral blend"
          },
          "Liquefied natural gas": {
            "impact": 0.20489,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels gaseous fuels lng', with value 0.20489 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - gaseous fuels - lng"
          },
          "Liquefied petroleum gas": {
            "impact": 0.271,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'LPG Liquefied Petroleum Gas for Vehicles (PCI)', with value 0.271 kgCO2eq/kWh for geography 'europe - france', from ademe v23.9 2025_23.9, within the following taxonomy: combustibles - fossils - liquid - mobile sources use - road use"
          },
          "Propane": {
            "impact": 0.268,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'Propane - maritime included (PCI)', with value 0.268 kgCO2eq/kWh for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: combustibles - fossils - gaseous - propane and butane"
          },
          "Butane": {
            "impact": 0.269,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'Butane - maritime included (PCI)', with value 0.269 kgCO2eq/kWh for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: combustibles - fossils - gaseous - propane and butane"
          },
          "Diesel 100 mineral diesel": {
            "impact": 0.26808,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels diesel 100 mineral diesel', with value 0.26808 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - diesel 100 mineral diesel"
          },
          "Diesel average biofuel blend": {
            "impact": 0.25953,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels diesel average biofuel blend', with value 0.25953 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - diesel average biofuel blend"
          },
          "Fuel oil": {
            "impact": 0.28523,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels fuel oil', with value 0.28523 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - fuel oil"
          },
          "Gas oil": {
            "impact": 0.27288,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels gas oil', with value 0.27288 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - gas oil"
          },
          "Burning oil": {
            "impact": 0.25975,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels burning oil', with value 0.25975 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - burning oil"
          },
          "Shale oil": {
            "impact": 0.723,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'Shale oil (PCI)', with value 0.723 kgCO2eq/kWh for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: combustibles - fossils - liquid - special uses"
          },
          "Waste oil": {
            "impact": 0.27459,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels waste oils', with value 0.27459 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - waste oils"
          },
          "Processed fuel oils distillate oil": {
            "impact": 0.27288,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels processed fuel oils distillate oil', with value 0.27288 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - processed fuel oils distillate oil"
          },
          "Processed fuel oils residual oil": {
            "impact": 0.28523,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels processed fuel oils residual oil', with value 0.28523 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - processed fuel oils residual oil"
          },
          "Marine fuel oil": {
            "impact": 0.27869,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels marine fuel oil', with value 0.27869 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - marine fuel oil"
          },
          "Marine gas oil": {
            "impact": 0.27445,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels marine gas oil', with value 0.27445 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - marine gas oil"
          },
          "Lubricants": {
            "impact": 0.281,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels lubricants', with value 0.281 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - lubricants"
          },
          "Naphtha": {
            "impact": 0.24891,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels naphtha', with value 0.24891 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - naphtha"
          },
          "Aviation spirit": {
            "impact": 0.25666,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels aviation spirit', with value 0.25666 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - aviation spirit"
          },
          "Aviation turbine fuel": {
            "impact": 0.26061,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels aviation turbine fuel', with value 0.26061 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - aviation turbine fuel"
          },
          "Petrol 100 mineral petrol": {
            "impact": 0.25431,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels petrol 100 mineral petrol', with value 0.25431 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - petrol 100 mineral petrol"
          },
          "Petrol average biofuel blend": {
            "impact": 0.23181,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels liquid fuels petrol average biofuel blend', with value 0.23181 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - liquid fuels - petrol average biofuel blend"
          }
        }
      },
      "Renewable": {
        "emission_factors": {
          "Biomass - wood pellets / wood chips": {
            "impact": 0.024,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Biogas / biomethane": {
            "impact": 0.022,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Liquid biofuels": {
            "impact": 0.05,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Solar thermal": {
            "impact": 0.01,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Geothermal": {
            "impact": 0.038,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Air-source heat pump": {
            "impact": 0.05,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Ground-source heat pump": {
            "impact": 0.04,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Industrial waste heat recovery": {
            "impact": 0.0,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Green hydrogen": {
            "impact": 0.05,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          }
        }
      }
    },
    "Market-based - contractual": {
      "Fossil": {
        "emission_factors": {
          "Natural gas": {
            "impact": 0.2027,
            "unit": "kgCO2eq/kWh",
            "description": "Original Emission Factor name: 'fuels gaseous fuels natural gas', with value 0.2027 kgCO2eq/kWh for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: fuels - gaseous fuels - natural gas"
          }
        }
      },
      "Renewable": {
        "emission_factors": {
          "Biomass - wood pellets / wood chips": {
            "impact": 0.024,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Biogas / biomethane": {
            "impact": 0.022,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Geothermal": {
            "impact": 0.038,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Solar thermal": {
            "impact": 0.01,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Air-source heat pump": {
            "impact": 0.05,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Ground-source heat pump": {
            "impact": 0.04,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Industrial waste heat recovery": {
            "impact": 0.0,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          },
          "Green hydrogen": {
            "impact": 0.05,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          }
        }
      }
    },
    "Location-based": {
      "NaN": {
        "emission_factors": {
          "District heat avg EF": {
            "impact": 0.18,
            "unit": "kgCO2eq/kWh",
            "description": "Placeholder pending EF refresh"
          }
        }
      }
    }
  },
  "Mineral resources": {
    "Glass": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - glass)": {
            "description": "Original Emission Factor name: 'ceramic glass', with value 2.874432866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: glass - materials - glass - other glass",
            "impact": 2.874432866666667,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Borosilicate glass": {
            "description": "Original Emission Factor name: 'borosilicate glass pyrex', with value 1.8023108 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: glass - materials - glass - other glass",
            "impact": 1.8023108,
            "unit": "kgCO2eq/kg"
          },
          "Ceramic glass": {
            "description": "Original Emission Factor name: 'ceramic glass', with value 2.874432866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: glass - materials - glass - other glass",
            "impact": 2.874432866666667,
            "unit": "kgCO2eq/kg"
          },
          "Flat glass": {
            "description": "Original Emission Factor name: 'Glass - flat , lead', with value 1.85 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - non metallic mineral products - glass glasses and articles - flat glasses",
            "impact": 1.85,
            "unit": "kgCO2eq/kg"
          },
          "Glass bottles (non recycled)": {
            "description": "Original Emission Factor name: 'glass bottles virgin', with value 1.4372164666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: glass - materials - glass - bottles",
            "impact": 1.4372164666666667,
            "unit": "kgCO2eq/kg"
          },
          "Glass bottles (recycled)": {
            "description": "Original Emission Factor name: 'glass bottles recycled average 74', with value 1.1203066666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: glass - materials - glass - bottles",
            "impact": 1.1203066666666668,
            "unit": "kgCO2eq/kg"
          },
          "Glass fibre": {
            "description": "Original Emission Factor name: 'glassfibre assembled roving for reinforcing thermosets', with value 2.02 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: fibres - materials - fibers",
            "impact": 2.02,
            "unit": "kgCO2eq/kg"
          },
          "Hollow glass": {
            "description": "Original Emission Factor name: 'Glass - packaging', with value 0.809 kgCO2eq/kg for geography 'europe', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - non metallic mineral products - glass glasses and articles - hollow glasses packing glasses",
            "impact": 0.809,
            "unit": "kgCO2eq/kg"
          },
          "Recycled borosilicate glass": {
            "description": "Original Emission Factor name: 'recycled borosilicate glass pyrex', with value 1.1484935333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: glass - materials - glass - other glass",
            "impact": 1.1484935333333333,
            "unit": "kgCO2eq/kg"
          },
          "Recycled silica glass": {
            "description": "Original Emission Factor name: 'recycled silica glass', with value 2.58571 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: glass - materials - glass - other glass",
            "impact": 2.58571,
            "unit": "kgCO2eq/kg"
          },
          "Silica glass": {
            "description": "Original Emission Factor name: 'silica glass', with value 2.874432866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: glass - materials - glass - other glass",
            "impact": 2.874432866666667,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Metal and metal ores": {
      "Aluminum": {
        "category_proxy": {
          "I don't know (aluminium primary)": {
            "description": "Original Emission Factor name: 'aluminium primary global average', with value 11.750991333333332 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 11.750991333333332,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Al99": {
            "description": "Original Emission Factor name: 'al99', with value 7.790617333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 7.790617333333333,
            "unit": "kgCO2eq/kg"
          },
          "Alcumg1 2017": {
            "description": "Original Emission Factor name: 'alcumg1 2017', with value 7.962288666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 7.962288666666668,
            "unit": "kgCO2eq/kg"
          },
          "Alcumg2 2024": {
            "description": "Original Emission Factor name: 'alcumg2 2024', with value 8.098929333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.098929333333334,
            "unit": "kgCO2eq/kg"
          },
          "Alcumgpb 2011": {
            "description": "Original Emission Factor name: 'alcumgpb 2011', with value 8.075980000000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.075980000000001,
            "unit": "kgCO2eq/kg"
          },
          "Alcusimg 2036": {
            "description": "Original Emission Factor name: 'alcusimg 2036', with value 7.938136666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 7.938136666666668,
            "unit": "kgCO2eq/kg"
          },
          "Almg1 5005": {
            "description": "Original Emission Factor name: 'almg1 5005', with value 8.264833333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.264833333333334,
            "unit": "kgCO2eq/kg"
          },
          "Almg3 5754a": {
            "description": "Original Emission Factor name: 'almg3 5754a', with value 8.399218666666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.399218666666666,
            "unit": "kgCO2eq/kg"
          },
          "Almg4.5mn 5182": {
            "description": "Original Emission Factor name: 'almg4.5mn 5182', with value 8.844019333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.844019333333334,
            "unit": "kgCO2eq/kg"
          },
          "Almgsi0.5 6060": {
            "description": "Original Emission Factor name: 'almgsi0.5 6060 and 6063', with value 8.157908666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.157908666666668,
            "unit": "kgCO2eq/kg"
          },
          "Almgsi0.7 6005": {
            "description": "Original Emission Factor name: 'almgsi0.7 6005', with value 8.181029333333335 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.181029333333335,
            "unit": "kgCO2eq/kg"
          },
          "Almn1 3003": {
            "description": "Original Emission Factor name: 'almn1 3003', with value 8.068053333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.068053333333333,
            "unit": "kgCO2eq/kg"
          },
          "Almn1.2mg1 3004": {
            "description": "Original Emission Factor name: 'almn1.2mg1 3004', with value 8.231127333333335 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.231127333333335,
            "unit": "kgCO2eq/kg"
          },
          "Alsimgmn 6009": {
            "description": "Original Emission Factor name: 'alsimgmn 6009', with value 8.160464666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.160464666666668,
            "unit": "kgCO2eq/kg"
          },
          "Aluminium secondary": {
            "description": "Original Emission Factor name: 'aluminium secondary', with value 0.7499516666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 0.7499516666666667,
            "unit": "kgCO2eq/kg"
          },
          "Aluminium trade mix 87.5 prim 12.5 sec": {
            "description": "Original Emission Factor name: 'aluminium trade mix global 64 prim 36 sec', with value 7.790617333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 7.790617333333333,
            "unit": "kgCO2eq/kg"
          },
          "Alzncumg 7075": {
            "description": "Original Emission Factor name: 'alzncumg 7075', with value 8.184942666666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.184942666666666,
            "unit": "kgCO2eq/kg"
          },
          "G alcu4timg 204": {
            "description": "Original Emission Factor name: 'g alcu4timg 204', with value 7.870169333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 7.870169333333334,
            "unit": "kgCO2eq/kg"
          },
          "G almg3 242": {
            "description": "Original Emission Factor name: 'g almg3 242', with value 8.557661333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.557661333333334,
            "unit": "kgCO2eq/kg"
          },
          "G almg5 314": {
            "description": "Original Emission Factor name: 'g almg5 314', with value 8.732401333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 8.732401333333334,
            "unit": "kgCO2eq/kg"
          },
          "G alsi12 230": {
            "description": "Original Emission Factor name: 'g alsi12 230', with value 7.761757333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 7.761757333333334,
            "unit": "kgCO2eq/kg"
          },
          "G alsi12cu 231": {
            "description": "Original Emission Factor name: 'g alsi12cu 231', with value 7.763131333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 7.763131333333333,
            "unit": "kgCO2eq/kg"
          },
          "G alsi7mg thixo": {
            "description": "Original Emission Factor name: 'g alsi7mg thixo', with value 7.963076666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 7.963076666666668,
            "unit": "kgCO2eq/kg"
          },
          "G alsi8cu3 380": {
            "description": "Original Emission Factor name: 'g alsi8cu3 380', with value 7.678142 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - aluminiums",
            "impact": 7.678142,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Copper": {
        "category_proxy": {
          "I don't know (copper primary)": {
            "description": "Original Emission Factor name: 'copper rod tube plate primary', with value 3.4506146 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 3.4506146,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Copper european copper instituut": {
            "description": "Original Emission Factor name: 'cusn8', with value 3.270093533333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.270093533333333,
            "unit": "kgCO2eq/kg"
          },
          "Copper secondary": {
            "description": "Original Emission Factor name: 'copper secondary', with value 0.43665366 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 0.43665366,
            "unit": "kgCO2eq/kg"
          },
          "Copper us study thinkstep tubes": {
            "description": "Original Emission Factor name: 'copper tube', with value 2.6838 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 2.6838,
            "unit": "kgCO2eq/kg"
          },
          "Copper wire plate pipe trade mix 45 prim 55 sec": {
            "description": "Original Emission Factor name: 'copper wire plate tube trade mix 68 prim 32 sec', with value 2.4861470666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 2.4861470666666667,
            "unit": "kgCO2eq/kg"
          },
          "Cu e": {
            "description": "Original Emission Factor name: 'copper e', with value 2.4861470666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 2.4861470666666667,
            "unit": "kgCO2eq/kg"
          },
          "Cuag e": {
            "description": "Original Emission Factor name: 'cuag e', with value 3.0239752 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.0239752,
            "unit": "kgCO2eq/kg"
          },
          "Cual5": {
            "description": "Original Emission Factor name: 'cual5', with value 3.0302713333333338 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.0302713333333338,
            "unit": "kgCO2eq/kg"
          },
          "Cuni10fe": {
            "description": "Original Emission Factor name: 'cuni10fe', with value 3.5326375333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.5326375333333333,
            "unit": "kgCO2eq/kg"
          },
          "Cuni18zn": {
            "description": "Original Emission Factor name: 'cuni18zn', with value 4.3909554 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 4.3909554,
            "unit": "kgCO2eq/kg"
          },
          "Cuni44mn": {
            "description": "Original Emission Factor name: 'cuni44mn', with value 6.4666634 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 6.4666634,
            "unit": "kgCO2eq/kg"
          },
          "Cusn6.7p": {
            "description": "Original Emission Factor name: 'cusn6.7p', with value 3.1680188000000005 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.1680188000000005,
            "unit": "kgCO2eq/kg"
          },
          "Cusn8": {
            "description": "Original Emission Factor name: 'cusn8', with value 3.270093533333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.270093533333333,
            "unit": "kgCO2eq/kg"
          },
          "Cuzn15": {
            "description": "Original Emission Factor name: 'cuzn15', with value 2.796418866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 2.796418866666667,
            "unit": "kgCO2eq/kg"
          },
          "Cuzn30": {
            "description": "Original Emission Factor name: 'cuzn30', with value 2.935596933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 2.935596933333333,
            "unit": "kgCO2eq/kg"
          },
          "Cuzn37": {
            "description": "Original Emission Factor name: 'cuzn37 brass', with value 3.000546733333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.000546733333333,
            "unit": "kgCO2eq/kg"
          },
          "Cuzn40": {
            "description": "Original Emission Factor name: 'g cuzn40', with value 3.028382333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.028382333333333,
            "unit": "kgCO2eq/kg"
          },
          "Cuzn40pb brass alpha beta machinable": {
            "description": "Original Emission Factor name: 'cuzn40pb brass alloy alpha beta machinable', with value 3.004062933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.004062933333333,
            "unit": "kgCO2eq/kg"
          },
          "G cual10fe": {
            "description": "Original Emission Factor name: 'g cual10fe', with value 3.1883733333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.1883733333333337,
            "unit": "kgCO2eq/kg"
          },
          "G cual10ni": {
            "description": "Original Emission Factor name: 'g cual10ni', with value 3.661760133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.661760133333333,
            "unit": "kgCO2eq/kg"
          },
          "G cuni10": {
            "description": "Original Emission Factor name: 'g cuni10', with value 3.5547806 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.5547806,
            "unit": "kgCO2eq/kg"
          },
          "G cusn10": {
            "description": "Original Emission Factor name: 'g cusn10', with value 3.4233067333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.4233067333333334,
            "unit": "kgCO2eq/kg"
          },
          "G cusn12": {
            "description": "Original Emission Factor name: 'g cusn12', with value 3.576519866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.576519866666667,
            "unit": "kgCO2eq/kg"
          },
          "G cusn5zn5pb5": {
            "description": "Original Emission Factor name: 'g cusn5zn5pb5', with value 3.056959066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.056959066666667,
            "unit": "kgCO2eq/kg"
          },
          "G cuzn15": {
            "description": "Original Emission Factor name: 'g cuzn15', with value 2.796418866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 2.796418866666667,
            "unit": "kgCO2eq/kg"
          },
          "G cuzn37pb": {
            "description": "Original Emission Factor name: 'g cuzn37pb', with value 3.0181568666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.0181568666666667,
            "unit": "kgCO2eq/kg"
          },
          "G cuzn40": {
            "description": "Original Emission Factor name: 'g cuzn40', with value 3.028382333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - coppers",
            "impact": 3.028382333333333,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Iron cast": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - iron cast)": {
            "description": "Original Emission Factor name: 'ggg60', with value 1.3848696 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 1.3848696,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Gg15": {
            "description": "Original Emission Factor name: 'gg15', with value 1.2159577333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 1.2159577333333336,
            "unit": "kgCO2eq/kg"
          },
          "Gg35": {
            "description": "Original Emission Factor name: 'gg35', with value 1.2159577333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 1.2159577333333336,
            "unit": "kgCO2eq/kg"
          },
          "Ggg nicr": {
            "description": "Original Emission Factor name: 'ggg nicr', with value 2.3753732000000003 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 2.3753732000000003,
            "unit": "kgCO2eq/kg"
          },
          "Ggg nisicr": {
            "description": "Original Emission Factor name: 'ggg nisicr', with value 2.424913 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 2.424913,
            "unit": "kgCO2eq/kg"
          },
          "Ggg40": {
            "description": "Original Emission Factor name: 'ggg40', with value 1.2159577333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 1.2159577333333336,
            "unit": "kgCO2eq/kg"
          },
          "Ggg60": {
            "description": "Original Emission Factor name: 'ggg60', with value 1.3848696 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 1.3848696,
            "unit": "kgCO2eq/kg"
          },
          "Ggg70": {
            "description": "Original Emission Factor name: 'ggg70', with value 1.2702236 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 1.2702236,
            "unit": "kgCO2eq/kg"
          },
          "Ggl nicucr": {
            "description": "Original Emission Factor name: 'ggl nicucr', with value 2.105781866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - cast irons",
            "impact": 2.105781866666667,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Magnesium": {
        "category_proxy": {
          "I don't know (magnesium crm primary)": {
            "description": "Original Emission Factor name: 'magnesium crm primary', with value 26.478787333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 26.478787333333337,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Am100a": {
            "description": "Original Emission Factor name: 'am100a', with value 23.409444666666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 23.409444666666666,
            "unit": "kgCO2eq/kg"
          },
          "Am503": {
            "description": "Original Emission Factor name: 'am503', with value 24.879904 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 24.879904,
            "unit": "kgCO2eq/kg"
          },
          "G mgal6zn3": {
            "description": "Original Emission Factor name: 'g mgal6zn3', with value 23.446838 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 23.446838,
            "unit": "kgCO2eq/kg"
          },
          "G mgal8zn1": {
            "description": "Original Emission Factor name: 'g mgal8zn1', with value 23.65968066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 23.65968066666667,
            "unit": "kgCO2eq/kg"
          },
          "G mgal9zn2": {
            "description": "Original Emission Factor name: 'g mgal9zn2', with value 23.153220666666662 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 23.153220666666662,
            "unit": "kgCO2eq/kg"
          },
          "Gd mgal9zn1": {
            "description": "Original Emission Factor name: 'gd mgal9zn1', with value 23.423512666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 23.423512666666667,
            "unit": "kgCO2eq/kg"
          },
          "Magnesium crm secondary": {
            "description": "Original Emission Factor name: 'magnesium crm secondary', with value 0.49311198 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 0.49311198,
            "unit": "kgCO2eq/kg"
          },
          "Magnesium crm trade mix 90 prim 10 sec": {
            "description": "Original Emission Factor name: 'magnesium crm trade mix 93 prim 7 sec', with value 24.65979 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 24.65979,
            "unit": "kgCO2eq/kg"
          },
          "Mgal3zn": {
            "description": "Original Emission Factor name: 'mgal3zn', with value 24.358150666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 24.358150666666667,
            "unit": "kgCO2eq/kg"
          },
          "Mgal6zn": {
            "description": "Original Emission Factor name: 'mgal6zn', with value 23.777568666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 23.777568666666667,
            "unit": "kgCO2eq/kg"
          },
          "Mgmn1.5": {
            "description": "Original Emission Factor name: 'mgmn1.5', with value 24.820870666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 24.820870666666668,
            "unit": "kgCO2eq/kg"
          },
          "Mgzn6zr": {
            "description": "Original Emission Factor name: 'mgzn6zr', with value 23.94752133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - magnesiums",
            "impact": 23.94752133333333,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Nickel": {
        "category_proxy": {
          "I don't know (nickel primary)": {
            "description": "Original Emission Factor name: 'nickel primary', with value 13.095508 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 13.095508,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Duranik": {
            "description": "Original Emission Factor name: 'duranickel', with value 11.492546666666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 11.492546666666666,
            "unit": "kgCO2eq/kg"
          },
          "Invar": {
            "description": "Original Emission Factor name: 'invar', with value 9.482429333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 9.482429333333334,
            "unit": "kgCO2eq/kg"
          },
          "Mumetal": {
            "description": "Original Emission Factor name: 'mumetal', with value 10.071874 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 10.071874,
            "unit": "kgCO2eq/kg"
          },
          "Ni 99.6": {
            "description": "Original Emission Factor name: 'nickel 99.6', with value 11.086946 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 11.086946,
            "unit": "kgCO2eq/kg"
          },
          "Ni span c902": {
            "description": "Original Emission Factor name: 'nickel span c902', with value 8.256258666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 8.256258666666668,
            "unit": "kgCO2eq/kg"
          },
          "Nickel secondary": {
            "description": "Original Emission Factor name: 'nickel secondary', with value 0.5419958933333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 0.5419958933333334,
            "unit": "kgCO2eq/kg"
          },
          "Nickel trade mix 66 prim 34 sec": {
            "description": "Original Emission Factor name: 'nickel trade mix 84 prim 16 sec', with value 11.086946 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 11.086946,
            "unit": "kgCO2eq/kg"
          },
          "Nicr 80 20": {
            "description": "Original Emission Factor name: 'nicr 80 20', with value 13.715960666666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 13.715960666666666,
            "unit": "kgCO2eq/kg"
          },
          "Nicr20co18ti": {
            "description": "Original Emission Factor name: 'nicr20co18ti', with value 18.24004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 18.24004,
            "unit": "kgCO2eq/kg"
          },
          "Nicr20tial": {
            "description": "Original Emission Factor name: 'nicr20tial', with value 14.062888666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 14.062888666666668,
            "unit": "kgCO2eq/kg"
          },
          "Nicu30al": {
            "description": "Original Emission Factor name: 'nicu30al', with value 10.505845333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 10.505845333333337,
            "unit": "kgCO2eq/kg"
          },
          "Nicu30fe": {
            "description": "Original Emission Factor name: 'nicu30fe', with value 8.711269333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 8.711269333333334,
            "unit": "kgCO2eq/kg"
          },
          "Nife 50 50": {
            "description": "Original Emission Factor name: 'nife 50 50', with value 7.443364666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 7.443364666666667,
            "unit": "kgCO2eq/kg"
          },
          "Nimo30": {
            "description": "Original Emission Factor name: 'nimo30', with value 13.480973333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 13.480973333333337,
            "unit": "kgCO2eq/kg"
          },
          "Supermalloy": {
            "description": "Original Emission Factor name: 'supermalloy', with value 10.09808 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - nickels",
            "impact": 10.09808,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Non ferro": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - non ferro)": {
            "description": "Proxy for category Mineral resources - Metal and metal ores - Non ferro has been calculated as 50th percentile of the emission factors within this category, namely -->                  Original Emission Factor name: 'lead primary', with value 2 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;          Original Emission Factor name: 'gold primary', with value 17,903.08 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;           Original Emission Factor name: 'gold secondary', with value 759.66 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;            Original Emission Factor name: 'silver primary', with value 123.7 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;             Original Emission Factor name: 'silver secondary', with value 13 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;                 Original Emission Factor name: 'molybdenum', with value 8.63 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;                 Original Emission Factor name: 'vanadium', with value 386.61 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;              Original Emission Factor name: 'chromium crm', with value 26.26 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;                 Original Emission Factor name: 'tellurium', with value 45.32 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;                 Original Emission Factor name: 'tantalum', with value 232.83 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro; Original Emission Factor name: 'platinum crm secondary', with value 1,113.30 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;  Original Emission Factor name: 'platinum crm primary', with value 13,891.60 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;                  Original Emission Factor name: 'manganese', with value 2.53 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;                       Original Emission Factor name: 'tin', with value 16.77 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro;             Original Emission Factor name: 'lead secondary', with value 0.68 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro",
            "impact": 45.32,
            "unit": "kgCO₂e/kg"
          }
        },
        "emission_factors": {
          "Chromium crm": {
            "description": "Original Emission Factor name: 'chromium crm eol rir 21', with value 21.706349333333332 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 21.706349333333332,
            "unit": "kgCO2eq/kg"
          },
          "Gold primary": {
            "description": "Original Emission Factor name: 'gold primary', with value 47790.3 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 47790.3,
            "unit": "kgCO2eq/kg"
          },
          "Gold secondary": {
            "description": "Original Emission Factor name: 'gold secondary', with value 750.6249333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 750.6249333333334,
            "unit": "kgCO2eq/kg"
          },
          "Lead primary": {
            "description": "Original Emission Factor name: 'lead primary', with value 1.892 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 1.892,
            "unit": "kgCO2eq/kg"
          },
          "Lead secondary": {
            "description": "Original Emission Factor name: 'lead secondary', with value 0.6071744466666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 0.6071744466666666,
            "unit": "kgCO2eq/kg"
          },
          "Manganese": {
            "description": "Original Emission Factor name: 'manganese', with value 2.53 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro",
            "impact": 2.53,
            "unit": "kgCO₂e/kg"
          },
          "Molybdenum": {
            "description": "Original Emission Factor name: 'molybdenum eol rir 9', with value 15.518727333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 15.518727333333334,
            "unit": "kgCO2eq/kg"
          },
          "Platinum crm primary": {
            "description": "Original Emission Factor name: 'platinum crm primary', with value 33300.0 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 33300.0,
            "unit": "kgCO2eq/kg"
          },
          "Platinum crm secondary": {
            "description": "Original Emission Factor name: 'platinum crm secondary', with value 1100.0538 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 1100.0538,
            "unit": "kgCO2eq/kg"
          },
          "Silver primary": {
            "description": "Original Emission Factor name: 'silver primary', with value 449.3869 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 449.3869,
            "unit": "kgCO2eq/kg"
          },
          "Silver secondary": {
            "description": "Original Emission Factor name: 'silver secondary', with value 14.373962 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 14.373962,
            "unit": "kgCO2eq/kg"
          },
          "Tantalum": {
            "description": "Original Emission Factor name: 'tantalum eol rir 13', with value 144.50005333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 144.50005333333334,
            "unit": "kgCO2eq/kg"
          },
          "Tellurium": {
            "description": "Original Emission Factor name: 'tellurium eol rir 1', with value 44.537884 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 44.537884,
            "unit": "kgCO2eq/kg"
          },
          "Tin": {
            "description": "Original Emission Factor name: 'tin virgin', with value 10.146806666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 10.146806666666668,
            "unit": "kgCO2eq/kg"
          },
          "Vanadium": {
            "description": "Original Emission Factor name: 'vanadium', with value 386.61 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - metals - non ferro",
            "impact": 386.61,
            "unit": "kgCO₂e/kg"
          }
        }
      },
      "Rare earth": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - rare earth)": {
            "description": "Original Emission Factor name: 'mischmetal cerium 67 lanthanum 20 neodimium 11 rest 2', with value 26.579966666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 26.579966666666667,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Cerium": {
            "description": "Original Emission Factor name: 'cerium', with value 25.95657933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 25.95657933333333,
            "unit": "kgCO2eq/kg"
          },
          "Dysprosium": {
            "description": "Original Emission Factor name: 'dysprosium', with value 121.14634 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 121.14634,
            "unit": "kgCO2eq/kg"
          },
          "Erbium": {
            "description": "Original Emission Factor name: 'erbium', with value 98.80982666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 98.80982666666668,
            "unit": "kgCO2eq/kg"
          },
          "Eutropium": {
            "description": "Original Emission Factor name: 'eutropium', with value 801.5828 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 801.5828,
            "unit": "kgCO2eq/kg"
          },
          "Gadolinium": {
            "description": "Original Emission Factor name: 'gadolinium', with value 94.67343333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 94.67343333333334,
            "unit": "kgCO2eq/kg"
          },
          "Idemat2022terbium": {
            "description": "Original Emission Factor name: 'terbium', with value 602.0019066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 602.0019066666667,
            "unit": "kgCO2eq/kg"
          },
          "Idemat2022ytterbium": {
            "description": "Original Emission Factor name: 'ytterbium', with value 253.51088666666664 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 253.51088666666664,
            "unit": "kgCO2eq/kg"
          },
          "Lanthanum": {
            "description": "Original Emission Factor name: 'lanthanum', with value 22.389982 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 22.389982,
            "unit": "kgCO2eq/kg"
          },
          "Mischmetal cerium 67 lanthanum 20 neodimium 11 rest 2": {
            "description": "Original Emission Factor name: 'mischmetal cerium 67 lanthanum 20 neodimium 11 rest 2', with value 26.579966666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 26.579966666666667,
            "unit": "kgCO2eq/kg"
          },
          "Neodymium": {
            "description": "Original Emission Factor name: 'neodymium', with value 35.72984666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 35.72984666666667,
            "unit": "kgCO2eq/kg"
          },
          "Praseodymium": {
            "description": "Original Emission Factor name: 'praseodymium', with value 39.03896 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 39.03896,
            "unit": "kgCO2eq/kg"
          },
          "Samarium": {
            "description": "Original Emission Factor name: 'samarium', with value 120.11224 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 120.11224,
            "unit": "kgCO2eq/kg"
          },
          "Scandium": {
            "description": "Original Emission Factor name: 'scandium', with value 8.870185333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 8.870185333333334,
            "unit": "kgCO2eq/kg"
          },
          "Yttrium": {
            "description": "Original Emission Factor name: 'yttrium', with value 30.662766 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - rare earth",
            "impact": 30.662766,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Steel cast": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - steel cast)": {
            "description": "Original Emission Factor name: 'gs 70', with value 2.3621296 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 2.3621296,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Gs 10ni6": {
            "description": "Original Emission Factor name: 'gs 10ni6', with value 2.646247133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 2.646247133333333,
            "unit": "kgCO2eq/kg"
          },
          "Gs 22mo4": {
            "description": "Original Emission Factor name: 'gs 22mo4', with value 2.6455772 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 2.6455772,
            "unit": "kgCO2eq/kg"
          },
          "Gs 25crmo4": {
            "description": "Original Emission Factor name: 'gs 25crmo4', with value 3.1602539333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 3.1602539333333337,
            "unit": "kgCO2eq/kg"
          },
          "Gs 45.3": {
            "description": "Original Emission Factor name: 'gs 45.3', with value 2.568732933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 2.568732933333333,
            "unit": "kgCO2eq/kg"
          },
          "Gs 70": {
            "description": "Original Emission Factor name: 'gs 70', with value 2.3621296 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 2.3621296,
            "unit": "kgCO2eq/kg"
          },
          "Gs x40crnisi 25 12": {
            "description": "Original Emission Factor name: 'gs x40crnisi 25 12', with value 8.447178000000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 8.447178000000001,
            "unit": "kgCO2eq/kg"
          },
          "Ha": {
            "description": "Original Emission Factor name: 'ha', with value 4.392232533333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 4.392232533333334,
            "unit": "kgCO2eq/kg"
          },
          "Ht": {
            "description": "Original Emission Factor name: 'ht', with value 8.500370666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel cast",
            "impact": 8.500370666666667,
            "unit": "kgCO2eq/kg"
          },
          "Steel hot rolled sheet": {
            "description": "Original Emission Factor name: 'steel market mix 9 eaf for beams sheet', with value 2.3256300000000003 kgCO2eq/kg for geography 'asia - china', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro",
            "impact": 2.3256300000000003,
            "unit": "kgCO2eq/kg"
          },
          "Steel secondary beams sheet": {
            "description": "Original Emission Factor name: 'steel from 100 scrap eaf for beams sheet', with value 0.6753 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro",
            "impact": 0.6753,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Steel construction": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - steel construction)": {
            "description": "Original Emission Factor name: 'fe520', with value 2.403876866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel construction",
            "impact": 2.403876866666667,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Fe360": {
            "description": "Original Emission Factor name: 'fe360', with value 2.403876866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel construction",
            "impact": 2.403876866666667,
            "unit": "kgCO2eq/kg"
          },
          "Fe470": {
            "description": "Original Emission Factor name: 'fe470', with value 2.403876866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel construction",
            "impact": 2.403876866666667,
            "unit": "kgCO2eq/kg"
          },
          "Fe520": {
            "description": "Original Emission Factor name: 'fe520', with value 2.403876866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel construction",
            "impact": 2.403876866666667,
            "unit": "kgCO2eq/kg"
          },
          "St13": {
            "description": "Original Emission Factor name: 'st13', with value 2.403876866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel construction",
            "impact": 2.403876866666667,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Steel draw": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - steel draw)": {
            "description": "Original Emission Factor name: 'a517a', with value 2.7030345333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel draw",
            "impact": 2.7030345333333337,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "A517a": {
            "description": "Original Emission Factor name: 'a517a', with value 2.7030345333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel draw",
            "impact": 2.7030345333333337,
            "unit": "kgCO2eq/kg"
          },
          "A517b": {
            "description": "Original Emission Factor name: 'a517b', with value 2.6713954 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel draw",
            "impact": 2.6713954,
            "unit": "kgCO2eq/kg"
          },
          "S355j2g1w": {
            "description": "Original Emission Factor name: 's355j2g1w', with value 2.403876866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel draw",
            "impact": 2.403876866666667,
            "unit": "kgCO2eq/kg"
          },
          "St14": {
            "description": "Original Emission Factor name: 'st14', with value 2.403876866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel draw",
            "impact": 2.403876866666667,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Steel high grade": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - steel high grade)": {
            "description": "Original Emission Factor name: '37mnsi5', with value 2.5794858 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.5794858,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "14nicr14": {
            "description": "Original Emission Factor name: '14nicr14', with value 3.1175152 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 3.1175152,
            "unit": "kgCO2eq/kg"
          },
          "15cr3": {
            "description": "Original Emission Factor name: '15cr3', with value 2.6541096000000004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.6541096000000004,
            "unit": "kgCO2eq/kg"
          },
          "18nicr8": {
            "description": "Original Emission Factor name: '18nicr8', with value 3.084832733333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 3.084832733333333,
            "unit": "kgCO2eq/kg"
          },
          "25crmo4": {
            "description": "Original Emission Factor name: '25crmo4', with value 2.7634233333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.7634233333333333,
            "unit": "kgCO2eq/kg"
          },
          "30crnimo8": {
            "description": "Original Emission Factor name: '30crnimo8', with value 3.136871666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 3.136871666666667,
            "unit": "kgCO2eq/kg"
          },
          "34cr4": {
            "description": "Original Emission Factor name: '34cr4', with value 2.747005933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.747005933333333,
            "unit": "kgCO2eq/kg"
          },
          "34cral6": {
            "description": "Original Emission Factor name: '34cral6', with value 2.8648216 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.8648216,
            "unit": "kgCO2eq/kg"
          },
          "35nicr18": {
            "description": "Original Emission Factor name: '35nicr18', with value 3.1648999333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 3.1648999333333334,
            "unit": "kgCO2eq/kg"
          },
          "36nicr6": {
            "description": "Original Emission Factor name: '36nicr6', with value 2.7539828 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.7539828,
            "unit": "kgCO2eq/kg"
          },
          "37mnsi5": {
            "description": "Original Emission Factor name: '37mnsi5', with value 2.5794858 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.5794858,
            "unit": "kgCO2eq/kg"
          },
          "42crmo4": {
            "description": "Original Emission Factor name: '42crmo4', with value 2.764641666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.764641666666667,
            "unit": "kgCO2eq/kg"
          },
          "50 crv4": {
            "description": "Original Emission Factor name: '50 crv4', with value 2.7697584 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.7697584,
            "unit": "kgCO2eq/kg"
          },
          "C15": {
            "description": "Original Emission Factor name: 'c15', with value 2.529326866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.529326866666667,
            "unit": "kgCO2eq/kg"
          },
          "C35": {
            "description": "Original Emission Factor name: 'c35', with value 2.653437733333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.653437733333333,
            "unit": "kgCO2eq/kg"
          },
          "C45": {
            "description": "Original Emission Factor name: 'c45', with value 2.6559106 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.6559106,
            "unit": "kgCO2eq/kg"
          },
          "C55": {
            "description": "Original Emission Factor name: 'c55', with value 2.531799666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.531799666666667,
            "unit": "kgCO2eq/kg"
          },
          "C60": {
            "description": "Original Emission Factor name: 'c60', with value 2.531799666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high grade",
            "impact": 2.531799666666667,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Steel high temperature": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - steel high temperature)": {
            "description": "Original Emission Factor name: '22mo4', with value 2.580691266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high temperature",
            "impact": 2.580691266666667,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "13crmo4 5 1.7335": {
            "description": "Original Emission Factor name: '13crmo4 5 1.7335', with value 2.756963133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high temperature",
            "impact": 2.756963133333333,
            "unit": "kgCO2eq/kg"
          },
          "21mov53": {
            "description": "Original Emission Factor name: '21mov53', with value 2.713436466666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high temperature",
            "impact": 2.713436466666667,
            "unit": "kgCO2eq/kg"
          },
          "22mo4": {
            "description": "Original Emission Factor name: '22mo4', with value 2.580691266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high temperature",
            "impact": 2.580691266666667,
            "unit": "kgCO2eq/kg"
          },
          "28nicrmo4": {
            "description": "Original Emission Factor name: '28nicrmo4', with value 2.6574348666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel high temperature",
            "impact": 2.6574348666666667,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Steel low temperature": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - steel low temperature)": {
            "description": "Original Emission Factor name: 'x12crni 18 9', with value 6.815486000000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel low temperature",
            "impact": 6.815486000000001,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "15nimn6 1.6228": {
            "description": "Original Emission Factor name: '15nimn6 1.6228', with value 2.6769708 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel low temperature",
            "impact": 2.6769708,
            "unit": "kgCO2eq/kg"
          },
          "A514 a": {
            "description": "Original Emission Factor name: 'a514 a', with value 2.689734266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel low temperature",
            "impact": 2.689734266666667,
            "unit": "kgCO2eq/kg"
          },
          "Ast35 1.0346": {
            "description": "Original Emission Factor name: 'ast35 1.0346', with value 2.5292133333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel low temperature",
            "impact": 2.5292133333333333,
            "unit": "kgCO2eq/kg"
          },
          "X12crni 18 9": {
            "description": "Original Emission Factor name: 'x12crni 18 9', with value 6.815486000000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel low temperature",
            "impact": 6.815486000000001,
            "unit": "kgCO2eq/kg"
          },
          "X12ni5 1.5680": {
            "description": "Original Emission Factor name: 'x12ni5 1.5680', with value 2.5772820666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel low temperature",
            "impact": 2.5772820666666667,
            "unit": "kgCO2eq/kg"
          },
          "X8ni9": {
            "description": "Original Emission Factor name: 'x8ni9', with value 3.303529133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel low temperature",
            "impact": 3.303529133333333,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Steel spring": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - metal and metal ores - steel spring)": {
            "description": "Original Emission Factor name: '55si7', with value 2.5799166 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel spring",
            "impact": 2.5799166,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "38si6": {
            "description": "Original Emission Factor name: '38si6', with value 2.5693108 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel spring",
            "impact": 2.5693108,
            "unit": "kgCO2eq/kg"
          },
          "50crv4": {
            "description": "Original Emission Factor name: '50crv4', with value 2.767288466666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel spring",
            "impact": 2.767288466666667,
            "unit": "kgCO2eq/kg"
          },
          "55si7": {
            "description": "Original Emission Factor name: '55si7', with value 2.5799166 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel spring",
            "impact": 2.5799166,
            "unit": "kgCO2eq/kg"
          },
          "67sicr5": {
            "description": "Original Emission Factor name: '67sicr5', with value 2.643325933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals ferro - materials - metals - ferro - steel spring",
            "impact": 2.643325933333333,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Titanium": {
        "category_proxy": {
          "I don't know (titanium primary)": {
            "description": "Original Emission Factor name: 'titanium primary', with value 27.752655333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 27.752655333333337,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Tial5sn2": {
            "description": "Original Emission Factor name: 'tial5sn2', with value 35.06821466666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - titaniums",
            "impact": 35.06821466666667,
            "unit": "kgCO2eq/kg"
          },
          "Tial6v4": {
            "description": "Original Emission Factor name: 'tial6v4', with value 34.83998066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - titaniums",
            "impact": 34.83998066666667,
            "unit": "kgCO2eq/kg"
          },
          "Titanium secondary": {
            "description": "Original Emission Factor name: 'titanium secondary', with value 17.55759466666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 17.55759466666667,
            "unit": "kgCO2eq/kg"
          },
          "Titanium trade mix 81 prim 19 sec": {
            "description": "Original Emission Factor name: 'titanium trade mix 99 prim 1 sec', with value 27.650704666666662 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 27.650704666666662,
            "unit": "kgCO2eq/kg"
          },
          "Tiv15sncral3": {
            "description": "Original Emission Factor name: 'tiv15sncral3', with value 33.44745266666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - titaniums",
            "impact": 33.44745266666666,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Zinc": {
        "category_proxy": {
          "I don't know (zinc primary)": {
            "description": "Original Emission Factor name: 'zinc primary', with value 3.818 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 3.818,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "G znalcu": {
            "description": "Original Emission Factor name: 'g znalcu', with value 4.4954504 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - zincs",
            "impact": 4.4954504,
            "unit": "kgCO2eq/kg"
          },
          "Zamak3": {
            "description": "Original Emission Factor name: 'zamak3', with value 4.440755133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - zincs",
            "impact": 4.440755133333333,
            "unit": "kgCO2eq/kg"
          },
          "Zamak5": {
            "description": "Original Emission Factor name: 'zamak5', with value 4.459401266666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - zincs",
            "impact": 4.459401266666666,
            "unit": "kgCO2eq/kg"
          },
          "Zinc secondary": {
            "description": "Original Emission Factor name: 'zinc secondary', with value 0.9322923333333332 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 0.9322923333333332,
            "unit": "kgCO2eq/kg"
          },
          "Zinc super plastic": {
            "description": "Original Emission Factor name: 'zinc super plastic', with value 5.0242004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - zincs",
            "impact": 5.0242004,
            "unit": "kgCO2eq/kg"
          },
          "Zinc trade mix 69 prim 31 sec": {
            "description": "Original Emission Factor name: 'zinc trade mix 86 prim 14 sec', with value 3.414000933333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro",
            "impact": 3.414000933333334,
            "unit": "kgCO2eq/kg"
          },
          "Zncuti": {
            "description": "Original Emission Factor name: 'zncuti', with value 4.493945066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: metals non ferro - materials - metals - non ferro - zincs",
            "impact": 4.493945066666667,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Mining, quarrying, construction": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for mineral resources - mining, quarrying, construction)": {
            "description": "Original Emission Factor name: 'cement portland cem i 52.5 n', with value 0.903 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - binders",
            "impact": 0.903,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Alumina": {
            "description": "Original Emission Factor name: 'alumina', with value 1.91 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 1.91,
            "unit": "kgCO2eq/kg"
          },
          "Aluminium nitride": {
            "description": "Original Emission Factor name: 'aluminium nitride', with value 5.323723879 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - ceramics",
            "impact": 5.323723879,
            "unit": "kgCO₂e/kg"
          },
          "Boron carbide": {
            "description": "Original Emission Factor name: 'boron carbide', with value 7.027232000000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 7.027232000000001,
            "unit": "kgCO2eq/kg"
          },
          "Cement blastfurnace cem iii b 42.5 n": {
            "description": "Original Emission Factor name: 'cement blastfurnace cem iii b 42.5 n', with value 0.4054036333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - binders",
            "impact": 0.4054036333333333,
            "unit": "kgCO2eq/kg"
          },
          "Cement portland cem i 52.5 n": {
            "description": "Original Emission Factor name: 'cement portland cem i 52.5 n', with value 0.903 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - binders",
            "impact": 0.903,
            "unit": "kgCO2eq/kg"
          },
          "Concrete": {
            "description": "Original Emission Factor name: 'Concrete', with value 0.088 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - non metallic mineral products - cement lime plaster concrete",
            "impact": 0.088,
            "unit": "kgCO2eq/kg"
          },
          "Germanium": {
            "description": "Original Emission Factor name: 'germanium', with value 842.6966666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 842.6966666666667,
            "unit": "kgCO2eq/kg"
          },
          "Gravel cement mix": {
            "description": "Original Emission Factor name: 'Gravel/cement mix', with value 0.0506 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - non metallic mineral products - coated for the road",
            "impact": 0.0506,
            "unit": "kgCO2eq/kg"
          },
          "Porcelain": {
            "description": "Original Emission Factor name: 'porcelain', with value 0.4197041266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 0.4197041266666667,
            "unit": "kgCO2eq/kg"
          },
          "Pzt piezo electric ceramic": {
            "description": "Original Emission Factor name: 'pzt piezo electric ceramic', with value 222.777 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 222.777,
            "unit": "kgCO2eq/kg"
          },
          "Quarry stones": {
            "description": "Original Emission Factor name: 'Quarry-stones', with value 0.011 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - minerals aggregates peat - career stones",
            "impact": 0.011,
            "unit": "kgCO2eq/kg"
          },
          "Reinforced concrete": {
            "description": "Original Emission Factor name: 'Reinforced concrete', with value 0.155 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - non metallic mineral products - cement lime plaster concrete",
            "impact": 0.155,
            "unit": "kgCO2eq/kg"
          },
          "Sand lime bricks light 600 kg m3": {
            "description": "Original Emission Factor name: 'sand lime bricks light 600 kg m3', with value 0.1335 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - bricks",
            "impact": 0.1335,
            "unit": "kgCO2eq/kg"
          },
          "Silicon carbide": {
            "description": "Original Emission Factor name: 'silicon carbide', with value 17.269436666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 17.269436666666667,
            "unit": "kgCO2eq/kg"
          },
          "Silicon nitride": {
            "description": "Original Emission Factor name: 'silicon nitride', with value 3.4000487333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 3.4000487333333336,
            "unit": "kgCO2eq/kg"
          },
          "Silicon purified for electronics and pv cells gross": {
            "description": "Original Emission Factor name: 'silicon purified for electronics and pv cells', with value 14.218534000000002 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 14.218534000000002,
            "unit": "kgCO2eq/kg"
          },
          "Stoneware": {
            "description": "Original Emission Factor name: 'stoneware', with value 0.4093389266666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 0.4093389266666666,
            "unit": "kgCO2eq/kg"
          },
          "Tungsten carbide": {
            "description": "Original Emission Factor name: 'tungsten carbide cobalt 11 primary from canada', with value 20.87265066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 20.87265066666667,
            "unit": "kgCO2eq/kg"
          },
          "Zirconia": {
            "description": "Original Emission Factor name: 'zirconia', with value 0.32 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: ceramics - materials - ceramics",
            "impact": 0.32,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    }
  },
  "Paper, wood, insulation": {
    "Insulation materials": {
      "NaN": {
        "category_proxy": {
          "I don't know (insulation material)": {
            "description": "Original Emission Factor name: 'construction insulation primary material production', with value 1.86179306 kgCO2eq/kg for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: material use - construction - insulation - primary material production",
            "impact": 1.86179306,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Cork granulate glued aggregate slab for insulation 150 kg m3": {
            "description": "Original Emission Factor name: 'cork granulate glued aggregate  slab for insulation 150 kg m3', with value 0.8239974666666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.8239974666666666,
            "unit": "kgCO2eq/kg"
          },
          "Cork slab insulation": {
            "description": "Original Emission Factor name: 'cork slab insulation', with value 0.8790448666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - insulation",
            "impact": 0.8790448666666667,
            "unit": "kgCO2eq/kg"
          },
          "Glasswool": {
            "description": "Original Emission Factor name: 'glasswool without paper plastic or aluminium facing', with value 1.36 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - insulation",
            "impact": 1.36,
            "unit": "kgCO2eq/kg"
          },
          "Stonewool": {
            "description": "Original Emission Factor name: 'stonewool without paper plastic or aluminium facing', with value 1.11 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: building materials - materials - construction - insulation",
            "impact": 1.11,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Papers": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for paper, wood, insulation - papers)": {
            "description": "Original Emission Factor name: 'brown paper kraft liner', with value 0.38092166 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: paper packaging - materials - paper and packaging - general",
            "impact": 0.38092166,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Board": {
            "description": "Original Emission Factor name: 'paper paper and board board primary material production', with value 1.19972542 kgCO2eq/kg for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: material use - paper - paper and board board - primary material production",
            "impact": 1.19972542,
            "unit": "kgCO2eq/kg"
          },
          "Board and recycled paper test liner and fluting": {
            "description": "Original Emission Factor name: 'board solid and recycled paper testliner and fluting in', with value 0.5995567266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: paper packaging - materials - paper and packaging - general",
            "impact": 0.5995567266666667,
            "unit": "kgCO2eq/kg"
          },
          "Brown paper kraft liner fsc": {
            "description": "Original Emission Factor name: 'brown paper kraft liner fsc or wood waste based', with value 0.38092166 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: paper packaging - materials - paper and packaging - general",
            "impact": 0.38092166,
            "unit": "kgCO2eq/kg"
          },
          "Brown paper kraft liner unsustainable": {
            "description": "Original Emission Factor name: 'brown paper kraft liner', with value 0.38092166 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: paper packaging - materials - paper and packaging - general",
            "impact": 0.38092166,
            "unit": "kgCO2eq/kg"
          },
          "Paper": {
            "description": "Original Emission Factor name: 'paper paper and board paper primary material production', with value 1.3450779 kgCO2eq/kg for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: material use - paper - paper and board paper - primary material production",
            "impact": 1.3450779,
            "unit": "kgCO2eq/kg"
          },
          "Paper woodfree uncoated virgin paper fsc": {
            "description": "Original Emission Factor name: 'paper woodfree uncoated bleached', with value 0.3894914733333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: paper packaging - materials - paper and packaging - general",
            "impact": 0.3894914733333333,
            "unit": "kgCO2eq/kg"
          },
          "Paper woodfree uncoated virgin paper unsustainable": {
            "description": "Original Emission Factor name: 'paper woodfree uncoated bleached', with value 0.3894914733333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: paper packaging - materials - paper and packaging - general",
            "impact": 0.3894914733333333,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Wood based materials": {
      "NaN": {
        "category_proxy": {
          "I don't know (wood)": {
            "description": "Original Emission Factor name: 'construction wood primary material production', with value 0.26950416 kgCO2eq/kg for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: material use - construction - wood - primary material production",
            "impact": 0.26950416,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Afrormosia fsc pefc 700 kg m3": {
            "description": "Original Emission Factor name: 'afrormosia fsc pefc 700 kg m3', with value 0.2264805466666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.2264805466666666,
            "unit": "kgCO2eq/kg"
          },
          "Afrormosia natural forest 700 kg m3": {
            "description": "Original Emission Factor name: 'afrormosia natural forest clear cut 700 kg m3', with value 3.6764805333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 3.6764805333333337,
            "unit": "kgCO2eq/kg"
          },
          "Afzelia fcs pefct 820 kg m3": {
            "description": "Original Emission Factor name: 'afzelia fcs pefc 820 kg m3', with value 0.21825036 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.21825036,
            "unit": "kgCO2eq/kg"
          },
          "Afzelia natural forest 820 kg m3": {
            "description": "Original Emission Factor name: 'afzelia natural forest clear cut 820 kg m3', with value 3.668250333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 3.668250333333333,
            "unit": "kgCO2eq/kg"
          },
          "Bamboo local at forest road china": {
            "description": "Original Emission Factor name: 'bamboo local at forest road', with value 0.1334477133333333 kgCO2eq/kg for geography 'asia - china', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.1334477133333333,
            "unit": "kgCO2eq/kg"
          },
          "Cca wood scots pine with cromium copper and asenic incl eol": {
            "description": "Original Emission Factor name: 'cca wood scots pine with cromium copper and asenic incl eol', with value 0.29173266 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.29173266,
            "unit": "kgCO2eq/kg"
          },
          "Cork at forest road 150 kg m3": {
            "description": "Original Emission Factor name: 'cork at forest road 150 kg m3', with value 0.19179 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.19179,
            "unit": "kgCO2eq/kg"
          },
          "Cork granulate 150 kg m3": {
            "description": "Original Emission Factor name: 'cork granulate 150 kg m3', with value 0.18783316 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.18783316,
            "unit": "kgCO2eq/kg"
          },
          "Dabema fsc pefc 690 kg m3": {
            "description": "Original Emission Factor name: 'dabema fsc pefc 690 kg m3', with value 0.2275779066666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.2275779066666666,
            "unit": "kgCO2eq/kg"
          },
          "Dabema natural forest 690 kg m3": {
            "description": "Original Emission Factor name: 'dabema natural forest clear cut 690 kg m3', with value 3.6775779333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 3.6775779333333336,
            "unit": "kgCO2eq/kg"
          },
          "Emien fsc pefc 360 kg m3": {
            "description": "Original Emission Factor name: 'emien fsc pefc 360 kg m3', with value 0.2709915866666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.2709915866666667,
            "unit": "kgCO2eq/kg"
          },
          "Emien natural forest 360 kg m3": {
            "description": "Original Emission Factor name: 'emien natural forest clear cut 360 kg m3', with value 3.720991600000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 3.720991600000001,
            "unit": "kgCO2eq/kg"
          },
          "Guaiacum wood fsc pefc 1250 kg m3": {
            "description": "Original Emission Factor name: 'guaiacum wood fsc pefc 1250 kg m3', with value 0.2138609266666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.2138609266666666,
            "unit": "kgCO2eq/kg"
          },
          "Guaiacum wood natural forest 1250 kg m3": {
            "description": "Original Emission Factor name: 'guaiacum wood natural forest clear cut 1250 kg m3', with value 3.663860933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 3.663860933333333,
            "unit": "kgCO2eq/kg"
          },
          "Iroko fsc pefc 650 kg m3": {
            "description": "Original Emission Factor name: 'iroko fsc pefc 650 kg m3', with value 0.2380028066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.2380028066666667,
            "unit": "kgCO2eq/kg"
          },
          "Iroko natural forest 650 kg m3": {
            "description": "Original Emission Factor name: 'iroko natural forest clear cut 650 kg m3', with value 3.688002800000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 3.688002800000001,
            "unit": "kgCO2eq/kg"
          },
          "Makore fsc pefc 660 kg m3": {
            "description": "Original Emission Factor name: 'makore fsc pefc 660 kg m3', with value 0.2281265866666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.2281265866666666,
            "unit": "kgCO2eq/kg"
          },
          "Makore natural forest 660 kg m3": {
            "description": "Original Emission Factor name: 'makore natural forest clear cut 660 kg m3', with value 3.6781266 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 3.6781266,
            "unit": "kgCO2eq/kg"
          },
          "Mansonia fsc pefc 620 kg m3": {
            "description": "Original Emission Factor name: 'mansonia fsc pefc 620 kg m3', with value 0.2336133733333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.2336133733333333,
            "unit": "kgCO2eq/kg"
          },
          "Mansonia natural forest 620 kg m3": {
            "description": "Original Emission Factor name: 'mansonia natural forest clear cut 620 kg m3', with value 3.683613400000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 3.683613400000001,
            "unit": "kgCO2eq/kg"
          },
          "Mdf at factury gate 740 kg m3": {
            "description": "Original Emission Factor name: 'mdf at factury gate', with value 0.6225316133333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.6225316133333334,
            "unit": "kgCO2eq/kg"
          },
          "Moabi fsc pefc 815 kg m3": {
            "description": "Original Emission Factor name: 'moabi fsc pefc 815 kg m3', with value 0.21879904 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.21879904,
            "unit": "kgCO2eq/kg"
          },
          "Moabi natural forest 815 kg m3": {
            "description": "Original Emission Factor name: 'moabi natural forest clear cut 815 kg m3', with value 3.6687990666666663 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 3.6687990666666663,
            "unit": "kgCO2eq/kg"
          },
          "Mubura fsc pefc 830 kg m3": {
            "description": "Original Emission Factor name: 'mubura fsc pefc 830 kg m3', with value 0.19794924 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.19794924,
            "unit": "kgCO2eq/kg"
          },
          "Mubura natural forest 830 kg m3": {
            "description": "Original Emission Factor name: 'mubura natural forest clear cut 830 kg m3', with value 3.647949266666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 3.647949266666666,
            "unit": "kgCO2eq/kg"
          },
          "Niove fsc pefc 850 kg m3": {
            "description": "Original Emission Factor name: 'niove fsc pefc 850 kg m3', with value 0.2171530066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.2171530066666667,
            "unit": "kgCO2eq/kg"
          },
          "Niove natural forest 850 kg m3": {
            "description": "Original Emission Factor name: 'niove natural forest clear cut 850 kg m3', with value 3.667153 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 3.667153,
            "unit": "kgCO2eq/kg"
          },
          "Oak european fsc pefc 710 kg m3": {
            "description": "Original Emission Factor name: 'oak fsc pefc 710 kg m3', with value 0.2011023266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class ii 15 25y",
            "impact": 0.2011023266666667,
            "unit": "kgCO2eq/kg"
          },
          "Onzabili fsc pefct 550 kg m3": {
            "description": "Original Emission Factor name: 'onzabili fsc pefct 550 kg m3', with value 0.24184356 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.24184356,
            "unit": "kgCO2eq/kg"
          },
          "Onzabili natural forest 550 kg m3": {
            "description": "Original Emission Factor name: 'onzabili natural forest clear cut 550 kg m3', with value 3.691843533333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 3.691843533333334,
            "unit": "kgCO2eq/kg"
          },
          "Parasolier fsc pefc 190 kg m3": {
            "description": "Original Emission Factor name: 'parasolier fsc pefc 190 kg m3', with value 0.4128385 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.4128385,
            "unit": "kgCO2eq/kg"
          },
          "Parasolier natural forest 190 kg m3": {
            "description": "Original Emission Factor name: 'parasolier natural forest clear cut 190 kg m3', with value 3.862838466666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 3.862838466666666,
            "unit": "kgCO2eq/kg"
          },
          "Particle board high humidity p5 rotterdam": {
            "description": "Original Emission Factor name: 'particle board high humidity p5 rotterdam', with value 0.8099018666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.8099018666666667,
            "unit": "kgCO2eq/kg"
          },
          "Particle board standard rotterdam": {
            "description": "Original Emission Factor name: 'particle board standard rotterdam', with value 0.6675535333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.6675535333333333,
            "unit": "kgCO2eq/kg"
          },
          "Pear fsc pefc 680 kg m3": {
            "description": "Original Emission Factor name: 'pear fsc pefc 680 kg m3', with value 0.1986448533333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.1986448533333333,
            "unit": "kgCO2eq/kg"
          },
          "Plywood bamboo density approx 700 kg m3": {
            "description": "Original Emission Factor name: 'plywood bamboo density approx 700 kg m3', with value 0.1802815933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.1802815933333333,
            "unit": "kgCO2eq/kg"
          },
          "Plywood indoor use softwood 600 kg m3": {
            "description": "Original Emission Factor name: 'plywood softwood 600 kg m3 indoor use', with value 0.6085979800000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.6085979800000001,
            "unit": "kgCO2eq/kg"
          },
          "Plywood outdoor use okoumei plantation 500 kg m3": {
            "description": "Original Emission Factor name: 'plywood okoumei plantation 500 kg m3 marine and outdoor use', with value 0.8472212666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - products",
            "impact": 0.8472212666666668,
            "unit": "kgCO2eq/kg"
          },
          "Pockwood fsc pefc1250 kg m3": {
            "description": "Original Emission Factor name: 'pockwood fsc pefc1250 kg m3', with value 0.2138609266666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.2138609266666666,
            "unit": "kgCO2eq/kg"
          },
          "Pockwood natural forest 1250 kg m3": {
            "description": "Original Emission Factor name: 'pockwood natural forest clear cut 1250 kg m3', with value 3.663860933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 3.663860933333333,
            "unit": "kgCO2eq/kg"
          },
          "Red oak fsc pefc 700 kg m3": {
            "description": "Original Emission Factor name: 'red oak fsc pefc 700 kg m3', with value 0.2600816933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class iv 5 10y",
            "impact": 0.2600816933333333,
            "unit": "kgCO2eq/kg"
          },
          "Robinia fsc pefc 740 kg m3": {
            "description": "Original Emission Factor name: 'robinia fsc pefc 740 kg m3', with value 0.2232195866666666 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.2232195866666666,
            "unit": "kgCO2eq/kg"
          },
          "Sterculia niangon fsc pefc 700 kg m3": {
            "description": "Original Emission Factor name: 'sterculia niangon fsc pefc 700 kg m3', with value 0.33088364 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 0.33088364,
            "unit": "kgCO2eq/kg"
          },
          "Sterculia niangon natural forest 700 kg m3": {
            "description": "Original Emission Factor name: 'sterculia niangon natural forest clear cut 700 kg m3', with value 3.7808836666666665 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - unknown durability",
            "impact": 3.7808836666666665,
            "unit": "kgCO2eq/kg"
          },
          "Teak fsc pefc 665 kg m3": {
            "description": "Original Emission Factor name: 'teak fsc pefc 665 kg m3', with value 0.2879326 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 0.2879326,
            "unit": "kgCO2eq/kg"
          },
          "Teak natural forest 665 kg m3": {
            "description": "Original Emission Factor name: 'teak natural forest clear cut 665 kg m3', with value 3.7379326 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: wood - materials - wood - class i 25y",
            "impact": 3.7379326,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    }
  },
  "Plastics & Rubber": {
    "Plastics": {
      "Biopolymers": {
        "category_proxy": {
          "I don't know (50th percentile for plastics & rubber - plastics - biopolymers)": {
            "description": "Original Emission Factor name: 'bio pe polyethylene from agricultural waste not biodegradable', with value 1.6366474666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - bioplastics",
            "impact": 1.6366474666666668,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Bio pe polyethylene not biodegradable": {
            "description": "Original Emission Factor name: 'bio pe polyethylene from agricultural waste not biodegradable', with value 1.6366474666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - bioplastics",
            "impact": 1.6366474666666668,
            "unit": "kgCO2eq/kg"
          },
          "Cellulose polymers biodegradable": {
            "description": "Original Emission Factor name: 'cellulose polymers biodegradable', with value 4.622618200000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - bioplastics",
            "impact": 4.622618200000001,
            "unit": "kgCO2eq/kg"
          },
          "Pa 11 nylon 11 bio based not biodegradable": {
            "description": "Original Emission Factor name: 'polyamide 11 nylon 11 bio based not biodegradable', with value 3.635 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - bioplastics",
            "impact": 3.635,
            "unit": "kgCO2eq/kg"
          },
          "Pha polyhydroxyalkanoates biodegradeble": {
            "description": "Original Emission Factor name: 'pha and phb polyhydroxyalkanoates from wastewater sludge biodegradable', with value 2.494879333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - bioplastics",
            "impact": 2.494879333333333,
            "unit": "kgCO2eq/kg"
          },
          "Pla polylactide biodegradeble": {
            "description": "Original Emission Factor name: 'pla polylactide of corn stover biodegradable', with value 3.543347266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - bioplastics",
            "impact": 3.543347266666667,
            "unit": "kgCO2eq/kg"
          },
          "Starch 0 pbs 100 polybutylene succinate biodegradable thermoplastic": {
            "description": "Original Emission Factor name: 'pbs polybutylene succinate biodegradable', with value 3.6884448 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - bioplastics",
            "impact": 3.6884448,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Thermoplasts, thermosets, special": {
        "category_proxy": {
          "I don't know (50th percentile for plastics & rubber - plastics - thermoplasts, thermosets, special)": {
            "description": "Original Emission Factor name: 'mf melamine formaldehyde resin', with value 1.770294 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 1.770294,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Abs 30 glass fibre": {
            "description": "Original Emission Factor name: 'abs 30 glass fibre', with value 2.354 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.354,
            "unit": "kgCO2eq/kg"
          },
          "Abs acrylonitrile butadiene styrene": {
            "description": "Original Emission Factor name: 'abs acrylonitrile butadiene styrene', with value 2.6900000000000004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.6900000000000004,
            "unit": "kgCO2eq/kg"
          },
          "Bisphenol a": {
            "description": "Original Emission Factor name: 'bisphenol a', with value 2.2636862 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 2.2636862,
            "unit": "kgCO2eq/kg"
          },
          "Cfrp 25 carbon": {
            "description": "Original Emission Factor name: 'carbon fiber reinforced plastic', with value 22.545255333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 22.545255333333337,
            "unit": "kgCO2eq/kg"
          },
          "Dehp phthalate": {
            "description": "Original Emission Factor name: 'dehp diisooctyl phthalate', with value 2.2 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 2.2,
            "unit": "kgCO2eq/kg"
          },
          "Dinp phthalate": {
            "description": "Original Emission Factor name: 'dinp diisononyl phthalate', with value 2.2 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 2.2,
            "unit": "kgCO2eq/kg"
          },
          "Epichlorohydrin": {
            "description": "Original Emission Factor name: 'epichlorohydrin', with value 2.0349 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 2.0349,
            "unit": "kgCO2eq/kg"
          },
          "Epoxy resin": {
            "description": "Original Emission Factor name: 'epoxy resin from bisphenol a 33 epichlorohydrin 66', with value 2.2992854 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 2.2992854,
            "unit": "kgCO2eq/kg"
          },
          "Evoh film barrier of gasses": {
            "description": "Original Emission Factor name: 'evoh ethylene vinyl alcohol film barrier of gasses', with value 5.230881066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 5.230881066666667,
            "unit": "kgCO2eq/kg"
          },
          "Formaldehyde": {
            "description": "Original Emission Factor name: 'formaldehyde', with value 0.9816811333333332 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 0.9816811333333332,
            "unit": "kgCO2eq/kg"
          },
          "Ionomer": {
            "description": "Original Emission Factor name: 'ionomer', with value 11.581897333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 11.581897333333334,
            "unit": "kgCO2eq/kg"
          },
          "Mdi": {
            "description": "Original Emission Factor name: 'mdi methylene diphenyl diisocyanate', with value 2.76 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 2.76,
            "unit": "kgCO2eq/kg"
          },
          "Mf resin": {
            "description": "Original Emission Factor name: 'mf melamine formaldehyde resin', with value 1.770294 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 1.770294,
            "unit": "kgCO2eq/kg"
          },
          "Mma monomer": {
            "description": "Original Emission Factor name: 'pmma polymethyl methacrylate', with value 3.9 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 3.9,
            "unit": "kgCO2eq/kg"
          },
          "Nafion": {
            "description": "Original Emission Factor name: 'nafion', with value 831.0000000000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 831.0000000000001,
            "unit": "kgCO2eq/kg"
          },
          "Paperfoam": {
            "description": "Original Emission Factor name: 'paperfoam', with value 0.7478833333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: paper packaging - materials - plastics - packaging micellanious",
            "impact": 0.7478833333333333,
            "unit": "kgCO2eq/kg"
          },
          "Pb polybutadiene": {
            "description": "Original Emission Factor name: 'butadiene rubber', with value 3.964 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 3.964,
            "unit": "kgCO2eq/kg"
          },
          "Pc 30 glass fibre": {
            "description": "Original Emission Factor name: 'pc 30 glass fibre', with value 2.851 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.851,
            "unit": "kgCO2eq/kg"
          },
          "Pc polycarbonate": {
            "description": "Original Emission Factor name: 'pc polycarbonate', with value 3.4000000000000004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 3.4000000000000004,
            "unit": "kgCO2eq/kg"
          },
          "Pe hdpe high density polyethylene": {
            "description": "Original Emission Factor name: 'pe hdpe high density polyethylene', with value 1.8000000000000005 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 1.8000000000000005,
            "unit": "kgCO2eq/kg"
          },
          "Pe ldpe low density polyethylene": {
            "description": "Original Emission Factor name: 'pe ldpe low density polyethylene', with value 1.8700000000000003 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 1.8700000000000003,
            "unit": "kgCO2eq/kg"
          },
          "Pe lldpe linear low density polyethylene": {
            "description": "Original Emission Factor name: 'pe lldpe linear low density polyethylene', with value 1.7900000000000005 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 1.7900000000000005,
            "unit": "kgCO2eq/kg"
          },
          "Pe polyethylene expanded": {
            "description": "Original Emission Factor name: 'pe polyethylene expanded epe', with value 2.450903266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.450903266666667,
            "unit": "kgCO2eq/kg"
          },
          "Peek polyetheretherketone": {
            "description": "Original Emission Factor name: 'peek polyetheretherketone', with value 179.1297414 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - special",
            "impact": 179.1297414,
            "unit": "kgCO₂e/kg"
          },
          "Pet 30 glass fibre": {
            "description": "Original Emission Factor name: 'pet polyethylene terephthalate 30 glass fibre', with value 2.004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.004,
            "unit": "kgCO2eq/kg"
          },
          "Pet amorphous": {
            "description": "Original Emission Factor name: 'pet polyethylene terephthalate amorphous', with value 2.0513377333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.0513377333333334,
            "unit": "kgCO2eq/kg"
          },
          "Pet bottle grade": {
            "description": "Original Emission Factor name: 'pet polyethylene terephthalate bottle grade', with value 2.1900000000000004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.1900000000000004,
            "unit": "kgCO2eq/kg"
          },
          "Pf resin": {
            "description": "Original Emission Factor name: 'pf phenol formaldehyde resin', with value 1.3563820000000002 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 1.3563820000000002,
            "unit": "kgCO2eq/kg"
          },
          "Phenolics bakelite": {
            "description": "Original Emission Factor name: 'phenolics bakelite', with value 1.6169819333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 1.6169819333333333,
            "unit": "kgCO2eq/kg"
          },
          "Phthalic anhydride": {
            "description": "Original Emission Factor name: 'phthalic anhydride', with value 3.270807466666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 3.270807466666667,
            "unit": "kgCO2eq/kg"
          },
          "Pmma polymethyl methacrylate": {
            "description": "Original Emission Factor name: 'pmma polymethyl methacrylate', with value 3.9 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 3.9,
            "unit": "kgCO2eq/kg"
          },
          "Polyamide 6 gf30": {
            "description": "Original Emission Factor name: 'polyamide 6 30 glass fibre', with value 3.635 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 3.635,
            "unit": "kgCO2eq/kg"
          },
          "Polyamide 6 nylon 6 polyamide 6": {
            "description": "Original Emission Factor name: 'polyamide 6 nylon 6 polyamide 6', with value 4.5200000000000005 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 4.5200000000000005,
            "unit": "kgCO2eq/kg"
          },
          "Polyamide 66 gf30": {
            "description": "Original Emission Factor name: 'polyamide 66 30 glass fibre', with value 4.9510000000000005 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 4.9510000000000005,
            "unit": "kgCO2eq/kg"
          },
          "Polyamide 66 nylon 66 polyamide 6 6": {
            "description": "Original Emission Factor name: 'polyamide 66 nylon 66 polyamide 6 6', with value 6.4 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 6.4,
            "unit": "kgCO2eq/kg"
          },
          "Polyester unsaturated": {
            "description": "Original Emission Factor name: 'polyester unsaturated resin', with value 1.8463603333333332 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 1.8463603333333332,
            "unit": "kgCO2eq/kg"
          },
          "Polyether polyols": {
            "description": "Original Emission Factor name: 'polyether polyols', with value 2.8750000000000004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 2.8750000000000004,
            "unit": "kgCO2eq/kg"
          },
          "Pom polyoxymethyleen polyacetaal": {
            "description": "Original Emission Factor name: 'pom polyoxymethyleen polyacetaal', with value 3.2 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 3.2,
            "unit": "kgCO2eq/kg"
          },
          "Pp gf30": {
            "description": "Original Emission Factor name: 'pp gf30', with value 1.612 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 1.612,
            "unit": "kgCO2eq/kg"
          },
          "Pp polypropylene": {
            "description": "Original Emission Factor name: 'pp polypropylene', with value 1.63 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 1.63,
            "unit": "kgCO2eq/kg"
          },
          "Pps polyphenylene sulfide": {
            "description": "Original Emission Factor name: 'pps polyphenylene sulfide', with value 7.166394 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 7.166394,
            "unit": "kgCO2eq/kg"
          },
          "Ps eps expandable polystyrene": {
            "description": "Original Emission Factor name: 'ps eps expandable polystyrene white', with value 2.28 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.28,
            "unit": "kgCO2eq/kg"
          },
          "Ps gpps general purpose polystyrene": {
            "description": "Original Emission Factor name: 'ps gpps general purpose polystyrene', with value 2.16 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.16,
            "unit": "kgCO2eq/kg"
          },
          "Ps hips high impact polysyrene": {
            "description": "Original Emission Factor name: 'ps hips high impact polysyrene', with value 2.2500000000000004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.2500000000000004,
            "unit": "kgCO2eq/kg"
          },
          "Ptfe teflon polytetrafluoroethylene": {
            "description": "Original Emission Factor name: 'ptfe polytetrafluoroethylene teflon', with value 12.0 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 12.0,
            "unit": "kgCO2eq/kg"
          },
          "Ptt polyltrimethylene terephthalate": {
            "description": "Original Emission Factor name: 'ptt polyltrimethylene terephthalate', with value 3.3241062666666665 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 3.3241062666666665,
            "unit": "kgCO2eq/kg"
          },
          "Pur flex. block foam tdi": {
            "description": "Original Emission Factor name: 'pur flex. block foam 34 tdi 66 polyols', with value 3.465692333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 3.465692333333333,
            "unit": "kgCO2eq/kg"
          },
          "Pur flex. moulded tdi": {
            "description": "Original Emission Factor name: 'pur flex. moulded tdi with flame retardant', with value 3.560533133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 3.560533133333333,
            "unit": "kgCO2eq/kg"
          },
          "Pur flex. moulded tdi with flame retardant": {
            "description": "Original Emission Factor name: 'pur flex. moulded tdi with flame retardant', with value 3.560533133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 3.560533133333333,
            "unit": "kgCO2eq/kg"
          },
          "Pur flex. moulded. mdi": {
            "description": "Original Emission Factor name: 'pur flex. moulded. 36 mdi 64 polyols', with value 3.584488533333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 3.584488533333334,
            "unit": "kgCO2eq/kg"
          },
          "Pur rigid foam mdi": {
            "description": "Original Emission Factor name: 'pur rigid foam 65 mdi 35 polyols', with value 3.4252841333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 3.4252841333333337,
            "unit": "kgCO2eq/kg"
          },
          "Pva wood glue": {
            "description": "Original Emission Factor name: 'pvoh polyvinyl alcohol and pva polyvinyl acetate wood glue', with value 3.25124 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 3.25124,
            "unit": "kgCO2eq/kg"
          },
          "Pvc polyvinylchloride emulsion polymerised": {
            "description": "Original Emission Factor name: 'pvc polyvinylchloride emulsion polymerised', with value 2.37 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.37,
            "unit": "kgCO2eq/kg"
          },
          "Pvc polyvinylchloride suspension polymerised": {
            "description": "Original Emission Factor name: 'pvc polyvinylchloride suspension polymerised', with value 2.22 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.22,
            "unit": "kgCO2eq/kg"
          },
          "Pvc polyvinylchloride trade mix": {
            "description": "Original Emission Factor name: 'pvc polyvinylchloride trade mix', with value 2.2500000000000004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 2.2500000000000004,
            "unit": "kgCO2eq/kg"
          },
          "Pvdc polyvinyliden chloride": {
            "description": "Original Emission Factor name: 'pvdc polyvinyliden chloride', with value 4.577 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 4.577,
            "unit": "kgCO2eq/kg"
          },
          "Pvoh or pva water soluble film": {
            "description": "Original Emission Factor name: 'pvoh polyvinyl alcohol and pva polyvinyl acetate wood glue', with value 3.25124 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermoplasts",
            "impact": 3.25124,
            "unit": "kgCO2eq/kg"
          },
          "Smc and dmc 25 gl": {
            "description": "Original Emission Factor name: 'sheet molding compound 25 glass fibre', with value 1.6500488 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 1.6500488,
            "unit": "kgCO2eq/kg"
          },
          "Smc and dmc 50 gl": {
            "description": "Original Emission Factor name: 'sheet molding compound 50 glass fibre', with value 1.7947073333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 1.7947073333333334,
            "unit": "kgCO2eq/kg"
          },
          "Tdi": {
            "description": "Original Emission Factor name: 'tdi toluene diisocyanate', with value 3.14 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - other",
            "impact": 3.14,
            "unit": "kgCO2eq/kg"
          },
          "Uf resin": {
            "description": "Original Emission Factor name: 'uf urea formaldehyde resin', with value 1.604036 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - thermosets",
            "impact": 1.604036,
            "unit": "kgCO2eq/kg"
          }
        }
      },
      "Upcycled plastics": {
        "category_proxy": {
          "I don't know (50th percentile for plastics & rubber - plastics - upcycled plastics)": {
            "description": "Original Emission Factor name: 'bio pe polyethylene chemical upcycled non biodegradable', with value 1.5282358 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 1.5282358,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Abs acrylonitrile butadiene styrene upcycled": {
            "description": "Original Emission Factor name: 'abs acrylonitrile butadiene styrene chemical upcycled', with value 2.4766023333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 2.4766023333333336,
            "unit": "kgCO2eq/kg"
          },
          "Cellelose acetate tetra bio degradable upcycled": {
            "description": "Original Emission Factor name: 'cellelose acetate tetra chemical upcycled', with value 4.622618266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 4.622618266666667,
            "unit": "kgCO2eq/kg"
          },
          "Eva ethylene vinyl acetate upcycled": {
            "description": "Original Emission Factor name: 'eva ethylene vinyl acetate chemical upcycled', with value 2.250798 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 2.250798,
            "unit": "kgCO2eq/kg"
          },
          "Flexible polymeer foam pe upcycled": {
            "description": "Original Emission Factor name: 'flexible polymeer foam pe upcycled', with value 2.093101034 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - upcycled plastics",
            "impact": 2.093101034,
            "unit": "kgCO₂e/kg"
          },
          "Ionomer upcycled": {
            "description": "Original Emission Factor name: 'ionomer chemical upcycled', with value 11.310133333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 11.310133333333336,
            "unit": "kgCO2eq/kg"
          },
          "Mechanical recycled pellets from clean plastic bottles downcycled": {
            "description": "Original Emission Factor name: 'rpvc mechanical recycled in ex transport', with value 0.29790598 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 0.29790598,
            "unit": "kgCO2eq/kg"
          },
          "Moulded recycled mixed polymer": {
            "description": "Original Emission Factor name: 'moulded recycled mixed polymer', with value 0.879742069 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - upcycled plastics",
            "impact": 0.879742069,
            "unit": "kgCO₂e/kg"
          },
          "Pa 11 nylon 11 not biodegradable upcycled": {
            "description": "Original Emission Factor name: 'polyamide 11 nylon 11 chemical upcycled not biodegradable', with value 3.635 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 3.635,
            "unit": "kgCO2eq/kg"
          },
          "Pc polycarbonate upclycled": {
            "description": "Original Emission Factor name: 'pc polycarbonate chemical upclycled', with value 3.3640608000000003 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 3.3640608000000003,
            "unit": "kgCO2eq/kg"
          },
          "Pe biobased not biodegradable upcycled": {
            "description": "Original Emission Factor name: 'bio pe polyethylene chemical upcycled non biodegradable', with value 1.5282358 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 1.5282358,
            "unit": "kgCO2eq/kg"
          },
          "Pe polyethylene upcycled": {
            "description": "Original Emission Factor name: 'pe hdpe high density polyethylene chemical upcycled', with value 1.5282358 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 1.5282358,
            "unit": "kgCO2eq/kg"
          },
          "Pet polyethylene terephthalate upcycled": {
            "description": "Original Emission Factor name: 'pet polyethylene terephthalate chemical upcycled', with value 1.2605742666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 1.2605742666666668,
            "unit": "kgCO2eq/kg"
          },
          "Pha polyhydroxyalkanoates biodegradeble upcycled": {
            "description": "Original Emission Factor name: 'pha and phb polyhydroxyalkanoates chemical upcycled biodegradeble', with value 2.494879333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 2.494879333333333,
            "unit": "kgCO2eq/kg"
          },
          "Pla polylactide starch based biodegradeble plastic upcycled": {
            "description": "Original Emission Factor name: 'pla polylactide starch based chemical upcycled biodegradeble', with value 3.543347266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 3.543347266666667,
            "unit": "kgCO2eq/kg"
          },
          "Pmma polymethyl methacrylate upcycled": {
            "description": "Original Emission Factor name: 'pmma polymethyl methacrylate chemical upcycled', with value 4.2797358 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 4.2797358,
            "unit": "kgCO2eq/kg"
          },
          "Polyamide nylons upcycled": {
            "description": "Original Emission Factor name: 'polyamide nylons chemical upcycled', with value 4.6098108 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 4.6098108,
            "unit": "kgCO2eq/kg"
          },
          "Pom polyoxymethylene upcycled": {
            "description": "Original Emission Factor name: 'pom polyoxymethylene chemical upcycled', with value 4.0340008 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 4.0340008,
            "unit": "kgCO2eq/kg"
          },
          "Pp polypropylene upcycled": {
            "description": "Original Emission Factor name: 'pp polypropylene chemical upcycled', with value 1.3582358 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 1.3582358,
            "unit": "kgCO2eq/kg"
          },
          "Ps polystyrene upcycled": {
            "description": "Original Emission Factor name: 'ps polystyrene chemical upcycled', with value 1.9239508000000003 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 1.9239508000000003,
            "unit": "kgCO2eq/kg"
          },
          "Ptfe teflon upcycled": {
            "description": "Original Emission Factor name: 'ptfe teflon chemical upcycled', with value 12.914839333333337 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 12.914839333333337,
            "unit": "kgCO2eq/kg"
          },
          "Ptt polyltrimethylene terephthalate upcycled": {
            "description": "Original Emission Factor name: 'ptt polyltrimethylene terephthalate chemical upcycled', with value 3.8338220666666665 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 3.8338220666666665,
            "unit": "kgCO2eq/kg"
          },
          "Pur polyurethane upcycled": {
            "description": "Original Emission Factor name: 'pur polyurethane chemical upcycled', with value 3.506858133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 3.506858133333333,
            "unit": "kgCO2eq/kg"
          },
          "Pvc polyvinylchloride upcycled": {
            "description": "Original Emission Factor name: 'pvc polyvinylchloride chemical upcycled', with value 2.3673958 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 2.3673958,
            "unit": "kgCO2eq/kg"
          },
          "Starch 0 pbs 100 biodegradeble plastic upcycled": {
            "description": "Original Emission Factor name: 'starch pbs 50 50 blend chemical upcycled biodegradeble', with value 2.1503922 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - recycled plastics",
            "impact": 2.1503922,
            "unit": "kgCO2eq/kg"
          },
          "Starch pbs 50 50 blend biodegradeble plastic upcycled": {
            "description": "Original Emission Factor name: 'starch pbs 50 50 blend biodegradeble plastic upcycled', with value 3.598138966 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - upcycled plastics",
            "impact": 3.598138966,
            "unit": "kgCO₂e/kg"
          }
        }
      }
    },
    "Rubber": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for plastics & rubber - rubber)": {
            "description": "Proxy for category Plastics & Rubber - Rubber has been calculated as 50th percentile of the emission factors within this category, namely -->                               Original Emission Factor name: 'natural rubber', with value 1.41 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers; Original Emission Factor name: 'epdm ethylene propylene diene monomer rubber', with value 2.46 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;                 Original Emission Factor name: 'sbr styrene butadiene rubber', with value 3.56 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;           Original Emission Factor name: 'polychloroprene neoprene cr rubber', with value 5.35 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;                          Original Emission Factor name: 'polyisoprene rubber', with value 2.69 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;                           Original Emission Factor name: 'nbr nitrile rubber', with value 3.69 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;          Original Emission Factor name: 'san styrene acrylonitrile copolymer', with value 2.96 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;           Original Emission Factor name: 'polyurethane rubber for shoe soles', with value 4.36 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;    Original Emission Factor name: 'and pib butadiene rubber and butyl rubber', with value 3.67 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;                         Original Emission Factor name: 'silicone rubber pdms', with value 7.33 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers;            Original Emission Factor name: 'eva ethylene vinyl acetate rubber', with value 3.65 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers",
            "impact": 3.65,
            "unit": "kgCO₂e/kg"
          }
        },
        "emission_factors": {
          "And pib butadiene rubber and butyl rubber": {
            "description": "Original Emission Factor name: 'and pib butadiene rubber and butyl rubber', with value 3.67 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - plastics - rubbers",
            "impact": 3.67,
            "unit": "kgCO₂e/kg"
          },
          "Epdm ethylene propylene diene monomer rubber": {
            "description": "Original Emission Factor name: 'epdm ethylene propylene diene monomer rubber', with value 3.5000000000000004 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 3.5000000000000004,
            "unit": "kgCO2eq/kg"
          },
          "Eva ethylene vinyl acetate rubber": {
            "description": "Original Emission Factor name: 'eva ethylene vinyl acetate rubber', with value 1.9471472 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 1.9471472,
            "unit": "kgCO2eq/kg"
          },
          "Natural rubber": {
            "description": "Original Emission Factor name: 'natural rubber from thailand in rotterdam', with value 1.3186337333333331 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 1.3186337333333331,
            "unit": "kgCO2eq/kg"
          },
          "Nbr nitrile rubber": {
            "description": "Original Emission Factor name: 'nbr nitrile rubber', with value 3.568424733333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 3.568424733333333,
            "unit": "kgCO2eq/kg"
          },
          "Polychloroprene neoprene cr rubber": {
            "description": "Original Emission Factor name: 'polychloroprene neoprene and cr rubber', with value 5.2550208666666665 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 5.2550208666666665,
            "unit": "kgCO2eq/kg"
          },
          "Polyisoprene rubber": {
            "description": "Original Emission Factor name: 'polyisoprene rubber', with value 2.3627226 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 2.3627226,
            "unit": "kgCO2eq/kg"
          },
          "Polyurethane rubber for shoe soles": {
            "description": "Original Emission Factor name: 'polyurethane rubber shoe soles mdi 41.4 polyols 58.5', with value 4.491487533333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 4.491487533333333,
            "unit": "kgCO2eq/kg"
          },
          "San styrene acrylonitrile copolymer": {
            "description": "Original Emission Factor name: 'san styrene acrylonitrile copolymer', with value 2.72 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 2.72,
            "unit": "kgCO2eq/kg"
          },
          "Sbr styrene butadiene rubber": {
            "description": "Original Emission Factor name: 'sbr styrene butadiene rubber', with value 3.462078266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 3.462078266666667,
            "unit": "kgCO2eq/kg"
          },
          "Silicone rubber pdms": {
            "description": "Original Emission Factor name: 'silicone rubber pdms', with value 7.28005 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: plastics - materials - plastics - rubbers",
            "impact": 7.28005,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    }
  },
  "Processed food & drinks": {
    "Alcohol": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for processed food & drinks - alcohol)": {
            "description": "Original Emission Factor name: 'Rum-based cocktail', with value 0.911 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 0.911,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Beer": {
            "description": "Original Emission Factor name: 'Beer', with value 1.12 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.12,
            "unit": "kgCO2eq/kg"
          },
          "Blackcurrant liqueur": {
            "description": "Original Emission Factor name: 'Blackcurrant liqueur', with value 1.48 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.48,
            "unit": "kgCO2eq/kg"
          },
          "Champagne": {
            "description": "Original Emission Factor name: 'Champagne', with value 1.23 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.23,
            "unit": "kgCO2eq/kg"
          },
          "Cider": {
            "description": "Original Emission Factor name: 'Cider', with value 1.06 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.06,
            "unit": "kgCO2eq/kg"
          },
          "Cocktail": {
            "description": "Original Emission Factor name: 'Cocktail', with value 1.06 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.06,
            "unit": "kgCO2eq/kg"
          },
          "Liqueur": {
            "description": "Original Emission Factor name: 'Liqueur', with value 1.39 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.39,
            "unit": "kgCO2eq/kg"
          },
          "Marsala wine": {
            "description": "Original Emission Factor name: 'Marsala wine', with value 1.19 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.19,
            "unit": "kgCO2eq/kg"
          },
          "Pastis anise flavoured spirit": {
            "description": "Original Emission Factor name: 'Pastis (anise-flavoured spirit)', with value 1.12 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.12,
            "unit": "kgCO2eq/kg"
          },
          "Pure alcohol": {
            "description": "Original Emission Factor name: 'Pure alcohol', with value 1.12 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.12,
            "unit": "kgCO2eq/kg"
          },
          "Rum based cocktail": {
            "description": "Original Emission Factor name: 'Rum-based cocktail', with value 0.911 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 0.911,
            "unit": "kgCO2eq/kg"
          },
          "Sake or rice wine": {
            "description": "Original Emission Factor name: 'Sake or rice wine', with value 1.12 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.12,
            "unit": "kgCO2eq/kg"
          },
          "Sangria": {
            "description": "Original Emission Factor name: 'Sangria', with value 1.43 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.43,
            "unit": "kgCO2eq/kg"
          },
          "Sparkling fruit wine": {
            "description": "Original Emission Factor name: 'Sparkling fruit wine', with value 1.24 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.24,
            "unit": "kgCO2eq/kg"
          },
          "Spirits": {
            "description": "Original Emission Factor name: 'Spirit made from wine', with value 1.12 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.12,
            "unit": "kgCO2eq/kg"
          },
          "Whiskey based cocktail": {
            "description": "Original Emission Factor name: 'Whiskey-based cocktail', with value 0.889 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 0.889,
            "unit": "kgCO2eq/kg"
          },
          "Wine": {
            "description": "Original Emission Factor name: 'Wine', with value 1.23 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.23,
            "unit": "kgCO2eq/kg"
          },
          "Wine based aperitif": {
            "description": "Original Emission Factor name: 'Wine-based aperitif', with value 1.1 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcoholic beverages",
            "impact": 1.1,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Fish": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for processed food & drinks - fish)": {
            "description": "Proxy for category Processed food & drinks - Fish has been calculated as 50th percentile of the emission factors within this category, namely -->                                                                                                                Original Emission Factor name: 'mackerel fresh', with value 6.3 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                                Original Emission Factor name: 'shrimps fresh', with value 0.41 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                                Original Emission Factor name: 'mussels fresh', with value 1.02 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                       Original Emission Factor name: 'herring fillet frozen', with value 13.08 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                               Original Emission Factor name: 'flatfish fresh', with value 6.35 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                               Original Emission Factor name: 'shrimps frozen', with value 2.64 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                               Original Emission Factor name: 'cod fish fresh', with value 0.11 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                                 Original Emission Factor name: 'trout frozen', with value 5.35 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;           Original Emission Factor name: 'fish', with value 8.46 kgCO₂e/kg for geography 'europe - france', from Ademe (Base Carbone v19.1), within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - inputs and compound dishes - compound dishes;                                                                                                       Original Emission Factor name: 'cod fish fillet frozen', with value 0.65 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                      Original Emission Factor name: 'mackerel fillet frozen', with value 13.08 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish;                                                                                                                 Original Emission Factor name: 'herring fresh', with value 6.3 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish; Original Emission Factor name: 'fish on skewer', with value 13.5 kgCO₂e/kg for geography 'europe - france', from Ademe (Base Carbone v19.1), within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - inputs and compound dishes - compound dishes;                                                                                                      Original Emission Factor name: 'flatfish fillet frozen', with value 14.52 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 6.3,
            "unit": "kgCO₂e/kg"
          }
        },
        "emission_factors": {
          "Cod fish fillet frozen": {
            "description": "Original Emission Factor name: 'cod meat packaging per 1 kg nl', with value 3.8629656666666663 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - fish",
            "impact": 3.8629656666666663,
            "unit": "kgCO2eq/kg"
          },
          "Cod fish fresh": {
            "description": "Original Emission Factor name: 'cod fish fresh', with value 0.11 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 0.11,
            "unit": "kgCO₂e/kg"
          },
          "Fish": {
            "description": "Original Emission Factor name: 'Fish', with value 8.79 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - inputs and compound dishes - compound dishes",
            "impact": 8.79,
            "unit": "kgCO2eq/kg"
          },
          "Fish on skewer": {
            "description": "Original Emission Factor name: 'Fish on skewer', with value 13.4 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - inputs and compound dishes - compound dishes",
            "impact": 13.4,
            "unit": "kgCO2eq/kg"
          },
          "Flatfish fillet frozen": {
            "description": "Original Emission Factor name: 'claresse catfish fillet meat packaging per 1 kg nl', with value 13.009746666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - fish",
            "impact": 13.009746666666668,
            "unit": "kgCO2eq/kg"
          },
          "Flatfish fresh": {
            "description": "Original Emission Factor name: 'plaice fillet meat packaging per 1 kg nl', with value 4.209237933333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - fish",
            "impact": 4.209237933333333,
            "unit": "kgCO2eq/kg"
          },
          "Herring fillet frozen": {
            "description": "Original Emission Factor name: 'herring fillet frozen', with value 13.08 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 13.08,
            "unit": "kgCO₂e/kg"
          },
          "Herring fresh": {
            "description": "Original Emission Factor name: 'herring fresh', with value 6.3 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 6.3,
            "unit": "kgCO₂e/kg"
          },
          "Mackerel fillet frozen": {
            "description": "Original Emission Factor name: 'mackerel fillet frozen', with value 13.08 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 13.08,
            "unit": "kgCO₂e/kg"
          },
          "Mackerel fresh": {
            "description": "Original Emission Factor name: 'mackerel fresh', with value 6.3 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 6.3,
            "unit": "kgCO₂e/kg"
          },
          "Mussels fresh": {
            "description": "Original Emission Factor name: 'mussels fresh', with value 1.02 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 1.02,
            "unit": "kgCO₂e/kg"
          },
          "Shrimps fresh": {
            "description": "Original Emission Factor name: 'shrimps fresh', with value 0.41 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 0.41,
            "unit": "kgCO₂e/kg"
          },
          "Shrimps frozen": {
            "description": "Original Emission Factor name: 'shrimps dutch peeled meat packaging per 1 kg nl', with value 5.8828782 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - fish",
            "impact": 5.8828782,
            "unit": "kgCO2eq/kg"
          },
          "Trout frozen": {
            "description": "Original Emission Factor name: 'trout meat packaging per 1 kg nl', with value 9.287483333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - fish",
            "impact": 9.287483333333334,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Grain mill, starches": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for processed food & drinks - grain mill, starches)": {
            "description": "Original Emission Factor name: 'Corn or maize grain', with value 0.812 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - cereals products - pasta rice and cereals",
            "impact": 0.812,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Corn or maize grain": {
            "description": "Original Emission Factor name: 'Corn or maize grain', with value 0.812 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - cereals products - pasta rice and cereals",
            "impact": 0.812,
            "unit": "kgCO2eq/kg"
          },
          "Maize corn starch": {
            "description": "Original Emission Factor name: 'Maize/corn starch', with value 1.08 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - cereals products - flours and pie pasta",
            "impact": 1.08,
            "unit": "kgCO2eq/kg"
          },
          "Potatoe starch": {
            "description": "Original Emission Factor name: 'potatoe starch', with value 0.6123395733333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - others",
            "impact": 0.6123395733333333,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Meat": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for processed food & drinks - meat)": {
            "description": "Original Emission Factor name: 'shoulder ham', with value 9.476926666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - meats",
            "impact": 9.476926666666667,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Beef": {
            "description": "Original Emission Factor name: 'Beef', with value 35.3 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - meats eggs fish - raw meats",
            "impact": 35.3,
            "unit": "kgCO2eq/kg"
          },
          "Beef steak fresh": {
            "description": "Original Emission Factor name: 'beef steak fresh', with value 42.6 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 42.6,
            "unit": "kgCO₂e/kg"
          },
          "Beef tenderloin fresh": {
            "description": "Original Emission Factor name: 'beef tenderloin fresh', with value 73.05 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 73.05,
            "unit": "kgCO₂e/kg"
          },
          "Burger": {
            "description": "Original Emission Factor name: 'Burger', with value 16.7 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - meats eggs fish - other meat products",
            "impact": 16.7,
            "unit": "kgCO2eq/kg"
          },
          "Chicken": {
            "description": "Original Emission Factor name: 'Chicken', with value 7.14 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - meats eggs fish - other meat products",
            "impact": 7.14,
            "unit": "kgCO2eq/kg"
          },
          "Chicken fresh": {
            "description": "Original Emission Factor name: 'chicken w skin meat packaging per 1 kg nl', with value 3.0753798666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - meat and poultry",
            "impact": 3.0753798666666667,
            "unit": "kgCO2eq/kg"
          },
          "Chicken frozen": {
            "description": "Original Emission Factor name: 'chicken w skin meat packaging per 1 kg nl', with value 3.0753798666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - meat and poultry",
            "impact": 3.0753798666666667,
            "unit": "kgCO2eq/kg"
          },
          "Ham and bacon fresh": {
            "description": "Original Emission Factor name: 'ham and bacon fresh', with value 3.13 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: meat and fish",
            "impact": 3.13,
            "unit": "kgCO₂e/kg"
          },
          "Meat balls": {
            "description": "Original Emission Factor name: 'Meat balls', with value 11.6 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - inputs and compound dishes - compound dishes",
            "impact": 11.6,
            "unit": "kgCO2eq/kg"
          },
          "Pork fresh": {
            "description": "Original Emission Factor name: 'pork 5 14 fat meat packaging per 1 kg nl', with value 7.105537333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - meat and poultry",
            "impact": 7.105537333333333,
            "unit": "kgCO2eq/kg"
          },
          "Turkey": {
            "description": "Original Emission Factor name: 'Turkey', with value 9.06 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - meats eggs fish - other meat products",
            "impact": 9.06,
            "unit": "kgCO2eq/kg"
          },
          "Veal": {
            "description": "Original Emission Factor name: 'Veal', with value 18.2 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - meats eggs fish - other meat products",
            "impact": 18.2,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Milk and dairy": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for processed food & drinks - milk and dairy)": {
            "description": "Original Emission Factor name: 'Yogurt', with value 2.14 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - milk and dairy products - fresh and similar dairy products",
            "impact": 2.14,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Cheese": {
            "description": "Original Emission Factor name: 'Hard cheese', with value 6.22 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - milk and dairy products - cheeses",
            "impact": 6.22,
            "unit": "kgCO2eq/kg"
          },
          "Cheese from goat s milk fresh": {
            "description": "Original Emission Factor name: 'Goat cheese from raw milk', with value 6.43 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - milk and dairy products - cheeses",
            "impact": 6.43,
            "unit": "kgCO2eq/kg"
          },
          "Cream full": {
            "description": "Original Emission Factor name: 'cream whipped in multilayer carton per 1000 ml nl', with value 4.997095466666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - milk and milk products",
            "impact": 4.997095466666667,
            "unit": "kgCO2eq/kg"
          },
          "Milk full fresh": {
            "description": "Original Emission Factor name: 'milk whole in multilayer carton per 1000 ml nl', with value 1.4292246666666668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - milk and milk products",
            "impact": 1.4292246666666668,
            "unit": "kgCO2eq/kg"
          },
          "Milk low fat fresh": {
            "description": "Original Emission Factor name: 'milk semi skimmed in multilayer carton per 1000 ml nl', with value 1.2379859333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - milk and milk products",
            "impact": 1.2379859333333334,
            "unit": "kgCO2eq/kg"
          },
          "Milk powder skimmed": {
            "description": "Original Emission Factor name: 'milk powder skimmed', with value 15.65 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: dairy",
            "impact": 15.65,
            "unit": "kgCO₂e/kg"
          },
          "Milk powder whole": {
            "description": "Original Emission Factor name: 'milk powder whole', with value 14.05 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: dairy",
            "impact": 14.05,
            "unit": "kgCO₂e/kg"
          },
          "Soft ripened round cheese with bloomy rind or processed or feta type": {
            "description": "Original Emission Factor name: 'Soft-ripened round cheese with bloomy rind', with value 5.03 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - milk and dairy products - cheeses",
            "impact": 5.03,
            "unit": "kgCO2eq/kg"
          },
          "Yogurt": {
            "description": "Original Emission Factor name: 'Yogurt', with value 2.14 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - milk and dairy products - fresh and similar dairy products",
            "impact": 2.14,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Oils and fats": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for processed food & drinks - oils and fats)": {
            "description": "Original Emission Factor name: 'Combined oil (mix of olive oil and seeds oil)', with value 2.72 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 2.72,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Blended fat vegetable and animal origins": {
            "description": "Original Emission Factor name: 'Blended fat (vegetable and animal origins)', with value 3.29 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - margarines",
            "impact": 3.29,
            "unit": "kgCO2eq/kg"
          },
          "Butter": {
            "description": "Original Emission Factor name: 'Butter', with value 7.82 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - butters",
            "impact": 7.82,
            "unit": "kgCO2eq/kg"
          },
          "Cocoa butter": {
            "description": "Original Emission Factor name: 'Cocoa butter', with value 27.1 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 27.1,
            "unit": "kgCO2eq/kg"
          },
          "Combined oil blended vegetable oils": {
            "description": "Original Emission Factor name: 'Combined oil (blended vegetable oils)', with value 3.02 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 3.02,
            "unit": "kgCO2eq/kg"
          },
          "Combined oil mix of olive oil and seeds oil": {
            "description": "Original Emission Factor name: 'Combined oil (mix of olive oil and seeds oil)', with value 2.72 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 2.72,
            "unit": "kgCO2eq/kg"
          },
          "Cottonseed oil": {
            "description": "Original Emission Factor name: 'Cottonseed oil', with value 2.49 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 2.49,
            "unit": "kgCO2eq/kg"
          },
          "Crude palm kernel oil refined": {
            "description": "Original Emission Factor name: 'crude palm kernel oil refined', with value 0.9340444 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - others",
            "impact": 0.9340444,
            "unit": "kgCO2eq/kg"
          },
          "Fish oil": {
            "description": "Original Emission Factor name: 'Salmon oil', with value 1.6 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - fish oils",
            "impact": 1.6,
            "unit": "kgCO2eq/kg"
          },
          "Frying oil": {
            "description": "Original Emission Factor name: 'Frying oil', with value 2.71 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 2.71,
            "unit": "kgCO2eq/kg"
          },
          "Grapeseed oil": {
            "description": "Original Emission Factor name: 'Grapeseed oil', with value 1.29 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 1.29,
            "unit": "kgCO2eq/kg"
          },
          "Hazelnut oil": {
            "description": "Original Emission Factor name: 'Hazelnut oil', with value 8.2 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 8.2,
            "unit": "kgCO2eq/kg"
          },
          "Lard or pork fat": {
            "description": "Original Emission Factor name: 'Lard or pork fat', with value 1.59 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - other fats",
            "impact": 1.59,
            "unit": "kgCO2eq/kg"
          },
          "Linseed oil": {
            "description": "Original Emission Factor name: 'Linseed oil', with value 3.56 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 3.56,
            "unit": "kgCO2eq/kg"
          },
          "Maize corn oil": {
            "description": "Original Emission Factor name: 'Maize/corn oil', with value 3.57 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 3.57,
            "unit": "kgCO2eq/kg"
          },
          "Olive oil": {
            "description": "Original Emission Factor name: 'Olive oil', with value 1.0 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 1.0,
            "unit": "kgCO2eq/kg"
          },
          "Palm kernel oil crude from trees": {
            "description": "Original Emission Factor name: 'palm kernel oil crude from trees', with value 0.6246440266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - others",
            "impact": 0.6246440266666667,
            "unit": "kgCO2eq/kg"
          },
          "Palm oil": {
            "description": "Original Emission Factor name: 'palm oil in rotterdam', with value 1.0131821333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - plant oils",
            "impact": 1.0131821333333333,
            "unit": "kgCO2eq/kg"
          },
          "Peanut oil": {
            "description": "Original Emission Factor name: 'Peanut oil', with value 4.26 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 4.26,
            "unit": "kgCO2eq/kg"
          },
          "Poultry fat": {
            "description": "Original Emission Factor name: 'Chicken fat', with value 1.71 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - other fats",
            "impact": 1.71,
            "unit": "kgCO2eq/kg"
          },
          "Rape oil europe": {
            "description": "Original Emission Factor name: 'rape oil', with value 0.5900494133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - plant oils",
            "impact": 0.5900494133333333,
            "unit": "kgCO2eq/kg"
          },
          "Rapeseed oil": {
            "description": "Original Emission Factor name: 'Rapeseed oil', with value 3.24 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 3.24,
            "unit": "kgCO2eq/kg"
          },
          "Sesame oil": {
            "description": "Original Emission Factor name: 'Sesame oil', with value 3.24 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 3.24,
            "unit": "kgCO2eq/kg"
          },
          "Solid vegetable fat margarine type": {
            "description": "Original Emission Factor name: 'Solid vegetable fat (margarine type)', with value 2.83 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 2.83,
            "unit": "kgCO2eq/kg"
          },
          "Soy oil": {
            "description": "Original Emission Factor name: 'Soy oil', with value 2.65 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 2.65,
            "unit": "kgCO2eq/kg"
          },
          "Soy oil refined at coast": {
            "description": "Original Emission Factor name: 'soybean oil refined at coast', with value 0.44382486 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - others",
            "impact": 0.44382486,
            "unit": "kgCO2eq/kg"
          },
          "Soybean oil crude degummed at coast": {
            "description": "Original Emission Factor name: 'soybean oil crude degummed at coast', with value 0.42316668 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - others",
            "impact": 0.42316668,
            "unit": "kgCO2eq/kg"
          },
          "Sunflower oil": {
            "description": "Original Emission Factor name: 'Sunflower oil', with value 2.58 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - vegetable oils and fats",
            "impact": 2.58,
            "unit": "kgCO2eq/kg"
          },
          "Vegetable fat like margarine": {
            "description": "Original Emission Factor name: 'Vegetable fat (like margarine)', with value 4.08 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fat - margarines",
            "impact": 4.08,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Soft drinks": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for processed food & drinks - soft drinks)": {
            "description": "Original Emission Factor name: 'Fruit soft drink', with value 0.439 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcohol free drinks",
            "impact": 0.439,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Fruit soft drink carbonated": {
            "description": "Original Emission Factor name: 'Fruit soft drink', with value 0.439 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcohol free drinks",
            "impact": 0.439,
            "unit": "kgCO2eq/kg"
          },
          "Fruit soft drink still": {
            "description": "Original Emission Factor name: 'Fruit soft drink', with value 0.439 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcohol free drinks",
            "impact": 0.439,
            "unit": "kgCO2eq/kg"
          },
          "Soft drink carbonated": {
            "description": "Original Emission Factor name: 'Soft drink', with value 0.512 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcohol free drinks",
            "impact": 0.512,
            "unit": "kgCO2eq/kg"
          },
          "Still soft drink with tea extract": {
            "description": "Original Emission Factor name: 'Still soft drink with tea extract', with value 0.523 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - drinks - alcohol free drinks",
            "impact": 0.523,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Vegetables": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for processed food & drinks - vegetables)": {
            "description": "Original Emission Factor name: 'cauliflower in plastic foil per 500 gram nl', with value 0.5122930400000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.5122930400000001,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Aubergine eggplant greenhouse": {
            "description": "Original Emission Factor name: 'aubergine eggplant greenhouse', with value 2.54 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 2.54,
            "unit": "kgCO₂e/kg"
          },
          "Beans canned": {
            "description": "Original Emission Factor name: 'brown beans in food can nl', with value 1.8395186666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - legumes",
            "impact": 1.8395186666666667,
            "unit": "kgCO2eq/kg"
          },
          "Bell pepper fresh from greenhouse": {
            "description": "Original Emission Factor name: 'sweet pepper in plastic foil per 500 gram nl', with value 1.7513759333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 1.7513759333333334,
            "unit": "kgCO2eq/kg"
          },
          "Broccoli fresh": {
            "description": "Original Emission Factor name: 'broccoli in plastic foil per 500 gram nl', with value 0.5122930400000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.5122930400000001,
            "unit": "kgCO2eq/kg"
          },
          "Carrots fresh": {
            "description": "Original Emission Factor name: 'carrots fresh', with value 0.08 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.08,
            "unit": "kgCO₂e/kg"
          },
          "Cauliflower fresh": {
            "description": "Original Emission Factor name: 'cauliflower in plastic foil per 500 gram nl', with value 0.5122930400000001 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.5122930400000001,
            "unit": "kgCO2eq/kg"
          },
          "Celery roote fresh": {
            "description": "Original Emission Factor name: 'celery roote fresh', with value 0.27 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.27,
            "unit": "kgCO₂e/kg"
          },
          "Courgette fresh": {
            "description": "Original Emission Factor name: 'courgette fresh', with value 0.13 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.13,
            "unit": "kgCO₂e/kg"
          },
          "Cucumber fresh greenhouse": {
            "description": "Original Emission Factor name: 'cucumber fresh greenhouse', with value 1.86 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 1.86,
            "unit": "kgCO₂e/kg"
          },
          "Elderberry": {
            "description": "Original Emission Factor name: 'Elderberry', with value 0.875 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - fruits",
            "impact": 0.875,
            "unit": "kgCO2eq/kg"
          },
          "Endive": {
            "description": "Original Emission Factor name: 'Green endive', with value 0.631 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - vegetables",
            "impact": 0.631,
            "unit": "kgCO2eq/kg"
          },
          "Fennele fresh": {
            "description": "Original Emission Factor name: 'fennele fresh', with value 0.2 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.2,
            "unit": "kgCO₂e/kg"
          },
          "Grape": {
            "description": "Original Emission Factor name: 'grape', with value 0.63 kgCO₂e/kg for geography 'europe - france', from Ademe (Base Carbone v19.1), within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - fruits",
            "impact": 0.63,
            "unit": "kgCO₂e/kg"
          },
          "Grapefruit": {
            "description": "Original Emission Factor name: 'Grapefruit', with value 1.18 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - fruits",
            "impact": 1.18,
            "unit": "kgCO2eq/kg"
          },
          "Green asparagus fresh": {
            "description": "Original Emission Factor name: 'green asparagus fresh', with value 0.62 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.62,
            "unit": "kgCO₂e/kg"
          },
          "Iceberg lettuce fresh": {
            "description": "Original Emission Factor name: 'lettuce not packed nl', with value 0.2230521133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.2230521133333333,
            "unit": "kgCO2eq/kg"
          },
          "Kale fresh": {
            "description": "Original Emission Factor name: 'kale curly in plastic foil per 500 gram nl', with value 0.2596551333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.2596551333333333,
            "unit": "kgCO2eq/kg"
          },
          "Lemon": {
            "description": "Original Emission Factor name: 'Lemon', with value 0.713 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - fruits",
            "impact": 0.713,
            "unit": "kgCO2eq/kg"
          },
          "Lentils canned": {
            "description": "Original Emission Factor name: 'brown beans in food can nl', with value 1.8395186666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - legumes",
            "impact": 1.8395186666666667,
            "unit": "kgCO2eq/kg"
          },
          "Lettuce fresh": {
            "description": "Original Emission Factor name: 'lettuce not packed nl', with value 0.2230521133333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.2230521133333333,
            "unit": "kgCO2eq/kg"
          },
          "Lettuce fresh greenhouse": {
            "description": "Original Emission Factor name: 'lettuce fresh greenhouse', with value 3.85 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 3.85,
            "unit": "kgCO₂e/kg"
          },
          "Melon": {
            "description": "Original Emission Factor name: 'Melon', with value 0.933 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - fruits",
            "impact": 0.933,
            "unit": "kgCO2eq/kg"
          },
          "Onion fresh": {
            "description": "Original Emission Factor name: 'onions in plastic net per 1 kg nl', with value 0.2399312066666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.2399312066666667,
            "unit": "kgCO2eq/kg"
          },
          "Peas canned": {
            "description": "Original Emission Factor name: 'peas and carrots in food can nl', with value 1.5010292 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 1.5010292,
            "unit": "kgCO2eq/kg"
          },
          "Plum": {
            "description": "Original Emission Factor name: 'Plum', with value 0.976 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - fruits",
            "impact": 0.976,
            "unit": "kgCO2eq/kg"
          },
          "Radish fresh from greenhouse": {
            "description": "Original Emission Factor name: 'radish fresh from greenhouse', with value 4.61 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 4.61,
            "unit": "kgCO₂e/kg"
          },
          "Red cabbage fresh": {
            "description": "Original Emission Factor name: 'red cabbage fresh', with value 0.18 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.18,
            "unit": "kgCO₂e/kg"
          },
          "Rhubarb": {
            "description": "Original Emission Factor name: 'Rhubarb', with value 1.77 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - fruits",
            "impact": 1.77,
            "unit": "kgCO2eq/kg"
          },
          "Salad": {
            "description": "Original Emission Factor name: 'Green salad', with value 0.948 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - vegetables",
            "impact": 0.948,
            "unit": "kgCO2eq/kg"
          },
          "Salsify": {
            "description": "Original Emission Factor name: 'Salsify', with value 0.936 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - vegetables",
            "impact": 0.936,
            "unit": "kgCO2eq/kg"
          },
          "Spinach fresh": {
            "description": "Original Emission Factor name: 'spinac fresh', with value 0.3 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.3,
            "unit": "kgCO₂e/kg"
          },
          "Tomatoes fresh from greenhouse": {
            "description": "Original Emission Factor name: 'tomato not packed nl', with value 0.8317595333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.8317595333333333,
            "unit": "kgCO2eq/kg"
          },
          "Vegetable rost": {
            "description": "Original Emission Factor name: 'Vegetable rosti', with value 1.21 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - inputs and compound dishes - compound dishes",
            "impact": 1.21,
            "unit": "kgCO2eq/kg"
          },
          "Vine tomatoes fresh from greenhouse": {
            "description": "Original Emission Factor name: 'tomato not packed nl', with value 0.8317595333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 0.8317595333333333,
            "unit": "kgCO2eq/kg"
          },
          "White asparagus fresh": {
            "description": "Original Emission Factor name: 'white asparagus fresh', with value 0.33 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.33,
            "unit": "kgCO₂e/kg"
          },
          "White cabbage fresh": {
            "description": "Original Emission Factor name: 'white cabbage fresh', with value 0.17 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: vegetables",
            "impact": 0.17,
            "unit": "kgCO₂e/kg"
          },
          "Zucchini fresh": {
            "description": "Original Emission Factor name: 'courgettes not packed nl', with value 2.0031777333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: food - material - food - vegetable",
            "impact": 2.0031777333333336,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    }
  },
  "Raw agricultural products": {
    "Animal products": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for raw agricultural products - animal products)": {
            "description": "Original Emission Factor name: 'Cow milk', with value 1.08 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - milk",
            "impact": 1.08,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Beef cattle": {
            "description": "Original Emission Factor name: 'Beef cattle', with value 13.9 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - cattle",
            "impact": 13.9,
            "unit": "kgCO2eq/kg"
          },
          "Broiler": {
            "description": "Original Emission Factor name: 'Broiler', with value 2.71 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - poultry - other poultry",
            "impact": 2.71,
            "unit": "kgCO2eq/kg"
          },
          "Calf": {
            "description": "Original Emission Factor name: 'Veal', with value 9.95 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - cattle",
            "impact": 9.95,
            "unit": "kgCO2eq/kg"
          },
          "Chicken": {
            "description": "Original Emission Factor name: 'Chicken', with value 9.33 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - meats eggs fish - raw meats",
            "impact": 9.33,
            "unit": "kgCO2eq/kg"
          },
          "Cow milk": {
            "description": "Original Emission Factor name: 'Cow milk', with value 1.08 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - milk",
            "impact": 1.08,
            "unit": "kgCO2eq/kg"
          },
          "Cull cow": {
            "description": "Original Emission Factor name: 'Cull cow', with value 11.1 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - cattle",
            "impact": 11.1,
            "unit": "kgCO2eq/kg"
          },
          "Cull ewe": {
            "description": "Original Emission Factor name: 'Cull ewe', with value 10.6 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - sheep",
            "impact": 10.6,
            "unit": "kgCO2eq/kg"
          },
          "Cull hen": {
            "description": "Original Emission Factor name: 'Cull hen', with value 6.34 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - poultry - other poultry",
            "impact": 6.34,
            "unit": "kgCO2eq/kg"
          },
          "Cull sow": {
            "description": "Original Emission Factor name: 'Cull sow', with value 11.3 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - pig",
            "impact": 11.3,
            "unit": "kgCO2eq/kg"
          },
          "Egg": {
            "description": "Original Emission Factor name: 'Egg', with value 2.22 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - poultry - other poultry",
            "impact": 2.22,
            "unit": "kgCO2eq/kg"
          },
          "Fattened pigs": {
            "description": "Original Emission Factor name: 'Fattened pig', with value 4.4 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - pig",
            "impact": 4.4,
            "unit": "kgCO2eq/kg"
          },
          "Lamb": {
            "description": "Original Emission Factor name: 'Lamb', with value 12.6 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - sheep",
            "impact": 12.6,
            "unit": "kgCO2eq/kg"
          },
          "Milk": {
            "description": "Original Emission Factor name: 'Cow milk', with value 1.08 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - milk",
            "impact": 1.08,
            "unit": "kgCO2eq/kg"
          },
          "Pig": {
            "description": "Original Emission Factor name: 'Pig', with value 2.95 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - pig",
            "impact": 2.95,
            "unit": "kgCO2eq/kg"
          },
          "Pigs": {
            "description": "Original Emission Factor name: 'Fattened pig', with value 4.4 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - pig",
            "impact": 4.4,
            "unit": "kgCO2eq/kg"
          },
          "Rabbit": {
            "description": "Original Emission Factor name: 'Rabbit', with value 2.75 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - other animal production",
            "impact": 2.75,
            "unit": "kgCO2eq/kg"
          },
          "Roasting duck": {
            "description": "Original Emission Factor name: 'Duck for roasting', with value 3.47 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - poultry - other poultry",
            "impact": 3.47,
            "unit": "kgCO2eq/kg"
          },
          "Turkey": {
            "description": "Original Emission Factor name: 'Turkey', with value 4.12 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - poultry - other poultry",
            "impact": 4.12,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Plant products": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for raw agricultural products - plant products)": {
            "description": "Original Emission Factor name: 'linseed produced in region', with value 0.941128 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - plant production",
            "impact": 0.941128,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Alfalfa": {
            "description": "Original Emission Factor name: 'Alfalfa', with value 0.222 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - feed",
            "impact": 0.222,
            "unit": "kgCO2eq/kg"
          },
          "Apple": {
            "description": "Original Emission Factor name: 'Apple', with value 0.0902 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.0902,
            "unit": "kgCO2eq/kg"
          },
          "Baled grass": {
            "description": "Original Emission Factor name: 'Baled grass', with value 0.104 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - feed",
            "impact": 0.104,
            "unit": "kgCO2eq/kg"
          },
          "Baled hay": {
            "description": "Original Emission Factor name: 'Baled hay', with value 0.091 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - feed",
            "impact": 0.091,
            "unit": "kgCO2eq/kg"
          },
          "Baled herbs": {
            "description": "Original Emission Factor name: 'Provence herbs', with value 1.56 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - various culinary aids and ingredients - herbs",
            "impact": 1.56,
            "unit": "kgCO2eq/kg"
          },
          "Banana": {
            "description": "Original Emission Factor name: 'Banana', with value 0.219 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.219,
            "unit": "kgCO2eq/kg"
          },
          "Barley straw": {
            "description": "Original Emission Factor name: 'Wheat straw', with value  kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.0,
            "unit": "kgCO2eq/kg"
          },
          "Bio cotton": {
            "description": "Original Emission Factor name: 'bio cotton', with value 0.7225146666666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - plant production",
            "impact": 0.7225146666666667,
            "unit": "kgCO2eq/kg"
          },
          "Cherry": {
            "description": "Original Emission Factor name: 'Cherry', with value 0.442 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.442,
            "unit": "kgCO2eq/kg"
          },
          "Chickpea": {
            "description": "Original Emission Factor name: 'Chickpea', with value 0.911 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - legumes",
            "impact": 0.911,
            "unit": "kgCO2eq/kg"
          },
          "Cider apple": {
            "description": "Original Emission Factor name: 'Cider apple', with value 0.0928 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.0928,
            "unit": "kgCO2eq/kg"
          },
          "Clementine": {
            "description": "Original Emission Factor name: 'Clementine', with value 0.302 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.302,
            "unit": "kgCO2eq/kg"
          },
          "Cocoa beans, sun-dried, agroforestry, at farm": {
            "description": "",
            "impact": 11.56,
            "unit": "kgCO₂e/kg"
          },
          "Cocoa beans, sun-dried, at farm": {
            "description": "",
            "impact": 15.33,
            "unit": "kgCO₂e/kg"
          },
          "Coconut": {
            "description": "Original Emission Factor name: 'Coconut', with value 2.5 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agro food products prepared dishes and drinks - fruits vegetables legumes and oilseeds - hull fruits and oleaginous seeds",
            "impact": 2.5,
            "unit": "kgCO2eq/kg"
          },
          "Corn silage": {
            "description": "Original Emission Factor name: 'Silage maize', with value 0.184 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - feed",
            "impact": 0.184,
            "unit": "kgCO2eq/kg"
          },
          "Cotton": {
            "description": "Original Emission Factor name: 'cotton', with value 1.2342819333333332 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - plant production",
            "impact": 1.2342819333333332,
            "unit": "kgCO2eq/kg"
          },
          "Durum wheat": {
            "description": "Original Emission Factor name: 'Durum wheat grain', with value 0.731 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.731,
            "unit": "kgCO2eq/kg"
          },
          "Feed barley": {
            "description": "Original Emission Factor name: 'Winter barley', with value 0.378 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.378,
            "unit": "kgCO2eq/kg"
          },
          "French bean": {
            "description": "Original Emission Factor name: 'French bean', with value 0.123 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - legumes",
            "impact": 0.123,
            "unit": "kgCO2eq/kg"
          },
          "Grain corn": {
            "description": "Original Emission Factor name: 'Maize grain', with value 0.387 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.387,
            "unit": "kgCO2eq/kg"
          },
          "Grape": {
            "description": "Original Emission Factor name: 'Grape', with value 0.392 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - grapes",
            "impact": 0.392,
            "unit": "kgCO2eq/kg"
          },
          "Grass silage": {
            "description": "Original Emission Factor name: 'Grass silage', with value 0.302 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - feed",
            "impact": 0.302,
            "unit": "kgCO2eq/kg"
          },
          "Grazed grass": {
            "description": "Original Emission Factor name: 'Grazed grass', with value 0.0724 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - feed",
            "impact": 0.0724,
            "unit": "kgCO2eq/kg"
          },
          "Hemp seed": {
            "description": "Original Emission Factor name: 'hemp seed', with value 0.56 kgCO₂e/kg for geography 'europe - france', from Ademe (Base Carbone v19.1), within the following taxonomy: purchases of goods - products of agriculture and fishing - plant products - legumes",
            "impact": 0.56,
            "unit": "kgCO₂e/kg"
          },
          "Jasmine rice": {
            "description": "Original Emission Factor name: 'Jasmine rice', with value 4.14 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 4.14,
            "unit": "kgCO2eq/kg"
          },
          "Jute fibres not degummed trade mix": {
            "description": "Original Emission Factor name: 'jute fibres trade mix', with value 0.9515157333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - plant production",
            "impact": 0.9515157333333334,
            "unit": "kgCO2eq/kg"
          },
          "Linseed": {
            "description": "Original Emission Factor name: 'linseed produced in region', with value 0.941128 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - plant production",
            "impact": 0.941128,
            "unit": "kgCO2eq/kg"
          },
          "Mango": {
            "description": "Original Emission Factor name: 'mango', with value 0.12 kgCO₂e/kg for geography 'europe - france', from Ademe (Base Carbone v19.1), within the following taxonomy: purchases of goods - products of agriculture and fishing - plant products - fruits",
            "impact": 0.12,
            "unit": "kgCO₂e/kg"
          },
          "Oats": {
            "description": "Original Emission Factor name: 'Oat grain', with value 0.549 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.549,
            "unit": "kgCO2eq/kg"
          },
          "Peach": {
            "description": "Original Emission Factor name: 'Peach', with value 0.197 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.197,
            "unit": "kgCO2eq/kg"
          },
          "Pear": {
            "description": "Original Emission Factor name: 'Pear', with value 0.0883 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.0883,
            "unit": "kgCO2eq/kg"
          },
          "Peas": {
            "description": "Original Emission Factor name: 'Spring pea', with value 0.347 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - legumes",
            "impact": 0.347,
            "unit": "kgCO2eq/kg"
          },
          "Pineapple": {
            "description": "Original Emission Factor name: 'Pineapple', with value 0.868 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.868,
            "unit": "kgCO2eq/kg"
          },
          "Silage grass": {
            "description": "Original Emission Factor name: 'Grass silage', with value 0.302 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - feed",
            "impact": 0.302,
            "unit": "kgCO2eq/kg"
          },
          "Silage sorghum": {
            "description": "Original Emission Factor name: 'Silage sorghum', with value 0.192 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - feed",
            "impact": 0.192,
            "unit": "kgCO2eq/kg"
          },
          "Soft wheat": {
            "description": "Original Emission Factor name: 'Soft wheat grain', with value 0.468 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.468,
            "unit": "kgCO2eq/kg"
          },
          "Sorghum": {
            "description": "Original Emission Factor name: 'Sorghum', with value 0.234 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.234,
            "unit": "kgCO2eq/kg"
          },
          "Soybean": {
            "description": "Original Emission Factor name: 'Soybean grain', with value 0.84 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - legumes",
            "impact": 0.84,
            "unit": "kgCO2eq/kg"
          },
          "Spring barley": {
            "description": "Original Emission Factor name: 'Spring barley', with value 0.424 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.424,
            "unit": "kgCO2eq/kg"
          },
          "Spring oats": {
            "description": "Original Emission Factor name: 'Spring oat grain', with value 0.362 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - pig",
            "impact": 0.362,
            "unit": "kgCO2eq/kg"
          },
          "Spring peas": {
            "description": "Original Emission Factor name: 'Spring pea', with value 0.347 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - legumes",
            "impact": 0.347,
            "unit": "kgCO2eq/kg"
          },
          "Spring wheat": {
            "description": "Original Emission Factor name: 'Spring wheat', with value 0.325 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.325,
            "unit": "kgCO2eq/kg"
          },
          "Strawberry": {
            "description": "Original Emission Factor name: 'Strawberry', with value 0.848 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - fruits",
            "impact": 0.848,
            "unit": "kgCO2eq/kg"
          },
          "Sugar, from sugar beet, at sugar refinery": {
            "description": "",
            "impact": 1.7,
            "unit": "kgCO₂e/kg"
          },
          "Sugar, from sugarcane, at sugar plant": {
            "description": "",
            "impact": 1.37,
            "unit": "kgCO₂e/kg"
          },
          "Triticale": {
            "description": "Original Emission Factor name: 'Triticale grain', with value 0.437 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.437,
            "unit": "kgCO2eq/kg"
          },
          "Triticale straw": {
            "description": "Original Emission Factor name: 'Wheat straw', with value  kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.0,
            "unit": "kgCO2eq/kg"
          },
          "Walnut": {
            "description": "Original Emission Factor name: 'Walnut', with value 1.47 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - nut",
            "impact": 1.47,
            "unit": "kgCO2eq/kg"
          },
          "Wheat straw": {
            "description": "Original Emission Factor name: 'Wheat straw', with value  kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.0,
            "unit": "kgCO2eq/kg"
          },
          "Winter barley": {
            "description": "Original Emission Factor name: 'Winter barley', with value 0.378 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.378,
            "unit": "kgCO2eq/kg"
          },
          "Winter oats": {
            "description": "Original Emission Factor name: 'Winter oat', with value 0.519 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.519,
            "unit": "kgCO2eq/kg"
          },
          "Winter peas": {
            "description": "Original Emission Factor name: 'Winter pea', with value 0.376 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - legumes",
            "impact": 0.376,
            "unit": "kgCO2eq/kg"
          },
          "Winter wheat": {
            "description": "Original Emission Factor name: 'Winter wheat', with value 0.439 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - cereals",
            "impact": 0.439,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Sea products": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for raw agricultural products - sea products)": {
            "description": "Original Emission Factor name: 'Large trout', with value 2.6 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 2.6,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Albacore": {
            "description": "Original Emission Factor name: 'Albacore', with value 4.19 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 4.19,
            "unit": "kgCO2eq/kg"
          },
          "Albacore tuna": {
            "description": "Original Emission Factor name: 'Albacore', with value 4.19 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 4.19,
            "unit": "kgCO2eq/kg"
          },
          "Atlantic herring": {
            "description": "Original Emission Factor name: 'Atlantic Herring', with value 0.52 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 0.52,
            "unit": "kgCO2eq/kg"
          },
          "Atlantic mackerel": {
            "description": "Original Emission Factor name: 'Atlantic Mackerel', with value 0.529 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 0.529,
            "unit": "kgCO2eq/kg"
          },
          "Bluefin tuna": {
            "description": "Original Emission Factor name: 'Bluefin Tuna', with value 1.81 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 1.81,
            "unit": "kgCO2eq/kg"
          },
          "Common sole": {
            "description": "Original Emission Factor name: 'Common Sole', with value 2.15 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 2.15,
            "unit": "kgCO2eq/kg"
          },
          "European anchovy": {
            "description": "Original Emission Factor name: 'European Anchovy', with value 0.443 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 0.443,
            "unit": "kgCO2eq/kg"
          },
          "European pilchard": {
            "description": "Original Emission Factor name: 'European Pilchard', with value 0.341 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 0.341,
            "unit": "kgCO2eq/kg"
          },
          "Gadidae": {
            "description": "Original Emission Factor name: 'Gadidae', with value 3.27 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 3.27,
            "unit": "kgCO2eq/kg"
          },
          "Large trout": {
            "description": "Original Emission Factor name: 'Large trout', with value 2.6 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 2.6,
            "unit": "kgCO2eq/kg"
          },
          "Mussels": {
            "description": "Original Emission Factor name: 'Mussels', with value 0.44 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sea products",
            "impact": 0.44,
            "unit": "kgCO2eq/kg"
          },
          "Saithe": {
            "description": "Original Emission Factor name: 'Saithe', with value 4.24 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 4.24,
            "unit": "kgCO2eq/kg"
          },
          "Scallop": {
            "description": "Original Emission Factor name: 'Great Scallop', with value 0.676 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 0.676,
            "unit": "kgCO2eq/kg"
          },
          "Sea bass or sea bream": {
            "description": "Original Emission Factor name: 'Sea bass or sea bream', with value 4.8 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 4.8,
            "unit": "kgCO2eq/kg"
          },
          "Seaweed": {
            "description": "Original Emission Factor name: 'Seaweed non-optimized production', with value 0.847 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - plant products - other plant products",
            "impact": 0.847,
            "unit": "kgCO2eq/kg"
          },
          "Skipjack": {
            "description": "Original Emission Factor name: 'Skipjack Tuna', with value 1.88 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 1.88,
            "unit": "kgCO2eq/kg"
          },
          "Small trout": {
            "description": "Original Emission Factor name: 'Small trout', with value 1.95 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - sea products - sin",
            "impact": 1.95,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    }
  },
  "Textiles": {
    "Cotton, Wool, Jute, Other": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for textiles - cotton, wool, jute, other)": {
            "description": "Original Emission Factor name: 'Wool', with value 3.0 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - sheep",
            "impact": 3.0,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Biocotton": {
            "description": "Original Emission Factor name: 'biocotton fibre from without global seatransport', with value 0.7225146666666667 kgCO2eq/kg for geography 'north america - united states', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 0.7225146666666667,
            "unit": "kgCO2eq/kg"
          },
          "Cotton fibre": {
            "description": "Original Emission Factor name: 'cotton fibre trade mix without global seatransport', with value 0.9365843333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 0.9365843333333334,
            "unit": "kgCO2eq/kg"
          },
          "Jute fibre degummed": {
            "description": "Original Emission Factor name: 'jute fibre including degumming market mix', with value 3.7193705333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 3.7193705333333336,
            "unit": "kgCO2eq/kg"
          },
          "Jute fibre not degummed": {
            "description": "Original Emission Factor name: 'jute fibres rainfed', with value 0.9515157333333334 kgCO2eq/kg for geography 'asia - india', from idemat 2025 2025, within the following taxonomy: agriculture - materials - agricultural - plant production",
            "impact": 0.9515157333333334,
            "unit": "kgCO2eq/kg"
          },
          "Kenaf fibre india degummed": {
            "description": "Original Emission Factor name: 'kenaf fibre including degumming', with value 2.6521101333333337 kgCO2eq/kg for geography 'asia - india', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 2.6521101333333337,
            "unit": "kgCO2eq/kg"
          },
          "Wool": {
            "description": "Original Emission Factor name: 'Wool', with value 3.0 kgCO2eq/kg for geography 'europe - france', from ademe 2020_23.2, within the following taxonomy: purchases of goods - agriculture and fishing products - animal products - sheep",
            "impact": 3.0,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Leather": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for textiles - leather)": {
            "description": "Original Emission Factor name: 'Post-tanning/ Finishing Leather - gate to gate process', with value 2.38 kgCO2eq/kg for geography 'asia', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - textiles and clothing - leather - shaping",
            "impact": 2.38,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Leather wet white grain split aldehyde tanning waste water bc": {
            "description": "Original Emission Factor name: 'Leather wet white (Grain Split, Aldehyde tanning, Waste Water bc) - door case', with value 0.904 kgCO2eq/kg for geography 'asia', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - textiles and clothing - leather - shaping",
            "impact": 0.904,
            "unit": "kgCO2eq/kg"
          },
          "Post tanning finishing leather": {
            "description": "Original Emission Factor name: 'Post-tanning/ Finishing Leather - gate to gate process', with value 2.38 kgCO2eq/kg for geography 'asia', from ademe v23.9 2025_23.9, within the following taxonomy: purchases of goods - textiles and clothing - leather - shaping",
            "impact": 2.38,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    },
    "Synthetics": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for textiles - synthetics)": {
            "description": "Original Emission Factor name: 'nylon pellets', with value 5.46 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 5.46,
            "unit": "kgCO2eq/kg"
          }
        },
        "emission_factors": {
          "Acryl 100 acrylonitrile polymer pellet production": {
            "description": "Original Emission Factor name: 'acryl 100 acrylonitrile polymer pellet production', with value 3.46 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - textiles",
            "impact": 3.46,
            "unit": "kgCO₂e/kg"
          },
          "Aramid st gr": {
            "description": "Original Emission Factor name: 'aramid st gr', with value 15.653773333333335 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: fibres - materials - fibers",
            "impact": 15.653773333333335,
            "unit": "kgCO2eq/kg"
          },
          "Elastane polyurethane polymer pellet production": {
            "description": "Original Emission Factor name: 'elastane polyurethane pellets', with value 3.7027385333333336 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 3.7027385333333336,
            "unit": "kgCO2eq/kg"
          },
          "Fleece from recycled pet bottles": {
            "description": "Original Emission Factor name: 'fleece from recycled pet bottles', with value 7.354273333333333 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 7.354273333333333,
            "unit": "kgCO2eq/kg"
          },
          "Nylon polymer pellet production": {
            "description": "Original Emission Factor name: 'nylon pellets', with value 5.46 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 5.46,
            "unit": "kgCO2eq/kg"
          },
          "Pet polymer pellet production": {
            "description": "Original Emission Factor name: 'polyester pet pellets', with value 2.0513377333333334 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 2.0513377333333334,
            "unit": "kgCO2eq/kg"
          },
          "Pla polylactide pellet production": {
            "description": "Original Emission Factor name: 'pla polylactide pellets', with value 3.543347266666667 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 3.543347266666667,
            "unit": "kgCO2eq/kg"
          },
          "Sorona ptt biobased": {
            "description": "Original Emission Factor name: 'sorona ptt biobased pellets', with value 3.3241062666666665 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 3.3241062666666665,
            "unit": "kgCO2eq/kg"
          },
          "Viscose production": {
            "description": "Original Emission Factor name: 'viscose production', with value 1.5 kgCO2eq/kg for geography 'global', from idemat 2025 2025, within the following taxonomy: textile - materials - textiles - materials",
            "impact": 1.5,
            "unit": "kgCO2eq/kg"
          }
        }
      }
    }
  },
  "Transport": {
    "Cargo ship": {
      "Bulk carrier": {
        "category_proxy": {
          "I don't know (bulk carrier average)": {
            "description": "Original Emission Factor name: 'cargo ship bulk carrier average', with value 3.53e-06 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - bulk carrier - average",
            "impact": 3.53e-6,
            "unit": "kgCO2eq/kg * km"
          }
        },
        "emission_factors": {
          "Bulk carrier a: 0-9,999 dwt": {
            "description": "Original Emission Factor name: 'cargo ship bulk carrier 09999 dwt', with value 2.956e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - bulk carrier - 09999 dwt",
            "impact": 2.956e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "Bulk carrier b: 10,000-34,999 dwt": {
            "description": "Original Emission Factor name: 'cargo ship bulk carrier 10 00034 999 dwt', with value 8e-06 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - bulk carrier - 10 00034 999 dwt",
            "impact": 8e-6,
            "unit": "kgCO2eq/kg * km"
          },
          "Bulk carrier c: 35,000-59,999 dwt": {
            "description": "Original Emission Factor name: 'cargo ship bulk carrier 35 00059 999 dwt', with value 5.77e-06 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - bulk carrier - 35 00059 999 dwt",
            "impact": 5.77e-6,
            "unit": "kgCO2eq/kg * km"
          },
          "Bulk carrier d: 60,000-99,999 dwt": {
            "description": "Original Emission Factor name: 'cargo ship bulk carrier 60 00099 999 dwt', with value 4.15e-06 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - bulk carrier - 60 00099 999 dwt",
            "impact": 4.15e-6,
            "unit": "kgCO2eq/kg * km"
          },
          "Bulk carrier e: 100,000-199,999 dwt": {
            "description": "Original Emission Factor name: 'cargo ship bulk carrier 100 000199 999 dwt', with value 3.04e-06 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - bulk carrier - 100 000199 999 dwt",
            "impact": 3.04e-6,
            "unit": "kgCO2eq/kg * km"
          },
          "Bulk carrier f: 200,000+ dwt": {
            "description": "Original Emission Factor name: 'cargo ship bulk carrier 200 000 dwt', with value 2.5300000000000003e-06 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - bulk carrier - 200 000 dwt",
            "impact": 2.5300000000000003e-6,
            "unit": "kgCO2eq/kg * km"
          }
        }
      },
      "Container ship": {
        "category_proxy": {
          "I don't know (container ship average)": {
            "description": "Original Emission Factor name: 'cargo ship container ship average', with value 1.6119999999999998e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - container ship - average",
            "impact": 1.6119999999999998e-5,
            "unit": "kgCO2eq/kg * km"
          }
        },
        "emission_factors": {
          "Container ship a: 0-999 teu": {
            "description": "Original Emission Factor name: 'cargo ship container ship 0999 teu', with value 3.675e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - container ship - 0999 teu",
            "impact": 3.675e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "Container ship b: 1,000-1,999 teu": {
            "description": "Original Emission Factor name: 'cargo ship container ship 10001999 teu', with value 3.2500000000000004e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - container ship - 10001999 teu",
            "impact": 3.2500000000000004e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "Container ship c: 2,000-2,999 teu": {
            "description": "Original Emission Factor name: 'cargo ship container ship 20002999 teu', with value 2.025e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - container ship - 20002999 teu",
            "impact": 2.025e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "Container ship d: 3,000-3,999 teu": {
            "description": "Original Emission Factor name: 'cargo ship container ship 30004999 teu', with value 1.681e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - container ship - 30004999 teu",
            "impact": 1.681e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "Container ship e: 4,000-7,999 teu": {
            "description": "Original Emission Factor name: 'cargo ship container ship 50007999 teu', with value 1.681e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - container ship - 50007999 teu",
            "impact": 1.681e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "Container ship f: 8,000+ teu": {
            "description": "Original Emission Factor name: 'cargo ship container ship 8000 teu', with value 1.266e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - container ship - 8000 teu",
            "impact": 1.266e-5,
            "unit": "kgCO2eq/kg * km"
          }
        }
      },
      "General cargo": {
        "category_proxy": {
          "I don't know (general cargo average)": {
            "description": "Original Emission Factor name: 'cargo ship general cargo average', with value 1.321e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - general cargo - average",
            "impact": 1.321e-5,
            "unit": "kgCO2eq/kg * km"
          }
        },
        "emission_factors": {
          "General cargo a: 0-4,999 dwt": {
            "description": "Original Emission Factor name: 'cargo ship general cargo 04999 dwt', with value 1.407e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - general cargo - 04999 dwt",
            "impact": 1.407e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "General cargo b: 5,000-9,999 dwt": {
            "description": "Original Emission Factor name: 'cargo ship general cargo 50009999 dwt', with value 1.6e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - general cargo - 50009999 dwt",
            "impact": 1.6e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "General cargo c: 10,000+ dwt": {
            "description": "Original Emission Factor name: 'cargo ship general cargo 10 000 dwt', with value 1.205e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - general cargo - 10 000 dwt",
            "impact": 1.205e-5,
            "unit": "kgCO2eq/kg * km"
          }
        }
      },
      "Specialized cargo": {
        "category_proxy": {
          "I don't know (50th percentile for transport - cargo ship - specialized cargo)": {
            "description": "Original Emission Factor name: 'cargo ship vehicle transport average', with value 3.852e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - vehicle transport - average",
            "impact": 3.852e-5,
            "unit": "kgCO2eq/kg * km"
          }
        },
        "emission_factors": {
          "Cargo vehicle transport": {
            "description": "Original Emission Factor name: 'cargo ship vehicle transport average', with value 3.852e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - vehicle transport - average",
            "impact": 3.852e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "Refrigerated cargo": {
            "description": "Original Emission Factor name: 'cargo ship refrigerated cargo all dwt', with value 1.306e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - cargo ship - refrigerated cargo - all dwt",
            "impact": 1.306e-5,
            "unit": "kgCO2eq/kg * km"
          }
        }
      }
    },
    "Freight aircraft": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for transport - freight aircraft)": {
            "description": "Original Emission Factor name: 'air traffic intercontinental min weight volume ratio 0.167 ton m3 tkm', with value 0.0005778733333333 kgCO2eq/kg * km for geography 'global', from idemat 2025 2025, within the following taxonomy: transport - transport - air",
            "impact": 0.0005778733333333,
            "unit": "kgCO2eq/kg * km"
          }
        },
        "emission_factors": {
          "Air traffic continental (short/medium haul)": {
            "description": "Original Emission Factor name: 'air traffic continental min weight volume ratio 0.167 ton m3 tkm', with value 0.0014152 kgCO2eq/kg * km for geography 'global', from idemat 2025 2025, within the following taxonomy: transport - transport - air",
            "impact": 0.0014152,
            "unit": "kgCO2eq/kg * km"
          },
          "Air traffic intercontinental (long haul)": {
            "description": "Original Emission Factor name: 'air traffic intercontinental min weight volume ratio 0.167 ton m3 tkm', with value 0.0005778733333333 kgCO2eq/kg * km for geography 'global', from idemat 2025 2025, within the following taxonomy: transport - transport - air",
            "impact": 0.0005778733333333,
            "unit": "kgCO2eq/kg * km"
          }
        }
      }
    },
    "Train": {
      "NaN": {
        "category_proxy": {
          "I don't know (freight train)": {
            "description": "Original Emission Factor name: 'freighting goods rail freight train', with value 2.779e-05 kgCO2eq/kg * km for geography 'global', from defra 2025 2025_1.0, within the following taxonomy: freighting goods - rail - freight train",
            "impact": 2.779e-5,
            "unit": "kgCO2eq/kg * km"
          }
        }
      }
    },
    "Truck": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for transport - truck)": {
            "description": "Original Emission Factor name: 'truck container 28 tonne net b7 min weight volume ratio 0.41 t m3 tkm', with value 7.372420666666666e-05 kgCO2eq/kg * km for geography 'global', from idemat 2025 2025, within the following taxonomy: transport - transport - road - truck diesel b7",
            "impact": 7.372420666666666e-5,
            "unit": "kgCO2eq/kg * km"
          }
        },
        "emission_factors": {
          "Truck container": {
            "description": "Original Emission Factor name: 'truck container 28 tonne net b7 min weight volume ratio 0.41 t m3 tkm', with value 7.372420666666666e-05 kgCO2eq/kg * km for geography 'global', from idemat 2025 2025, within the following taxonomy: transport - transport - road - truck diesel b7",
            "impact": 7.372420666666666e-5,
            "unit": "kgCO2eq/kg * km"
          },
          "Truck trailer": {
            "description": "Original Emission Factor name: 'truck trailer 24 tonne net b7 min weight volume ratio 0.32 t m3 tkm', with value 8.601157333333334e-05 kgCO2eq/kg * km for geography 'global', from idemat 2025 2025, within the following taxonomy: transport - transport - road - truck diesel b7",
            "impact": 8.601157333333334e-5,
            "unit": "kgCO2eq/kg * km"
          }
        }
      }
    }
  },
  "Water": {
    "NaN": {
      "NaN": {
        "category_proxy": {
          "I don't know (50th percentile for water)": {
            "description": "Proxy for category Water has been calculated as 50th percentile of the emission factors within this category, namely -->                      Original Emission Factor name: 'drinking water europe', with value 0 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - water; Original Emission Factor name: 'industrial reverse osmosis water europe', with value 0.01 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - water",
            "impact": 0.005,
            "unit": "kgCO₂e/kg"
          }
        },
        "emission_factors": {
          "Drinking water europe": {
            "description": "Original Emission Factor name: 'drinking water europe', with value 0 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - water",
            "impact": 0.0,
            "unit": "kgCO₂e/kg"
          },
          "Industrial reverse osmosis water europe": {
            "description": "Original Emission Factor name: 'industrial reverse osmosis water europe', with value 0.01 kgCO₂e/kg for geography 'global', from Idemat (version 2022RevA), within the following taxonomy: materials - water",
            "impact": 0.01,
            "unit": "kgCO₂e/kg"
          }
        }
      }
    }
  }
}
